webpackJsonp([5],{

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setLang; });
/* unused harmony export parsedData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getObjects; });
/* unused harmony export getValues */
/* unused harmony export getKeys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return us; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return disableTouchMove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return detectIE; });
/* unused harmony export iOSVersion */
/* unused harmony export sortByDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



function us(type) {
  var ww = window.innerWidth;
  var wh = window.innerHeight;
  var ws = window.pageYOffset;

  switch (type) {
    case 'ww':
      return ww;
    case 'wh':
      return wh;
    case 'ws':
      return ws;
    default:
      break;
  }
}

function isMobile(device) {
  var isMobile = {
    android: function android() {
      return navigator.userAgent.match(/Android/i);
    },
    blackBerry: function blackBerry() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function iOS() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    iOSMobile: function iOSMobile() {
      return navigator.userAgent.match(/iPhone|iPod/i);
    },
    iOSTablet: function iOSTablet() {
      return navigator.userAgent.match(/iPad/i);
    },
    opera: function opera() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    windows: function windows() {
      return navigator.userAgent.match(/IEMobile/i);
    },
    mobileOnly: function mobileOnly() {
      return isMobile.android() || isMobile.blackBerry() || isMobile.iOSMobile() || isMobile.opera() || isMobile.windows();
    },
    all: function all() {
      return isMobile.android() || isMobile.blackBerry() || isMobile.iOS() || isMobile.opera() || isMobile.windows();
    }
  };
  switch (device) {
    case 'android':
      return isMobile.android();
    case 'blackBerry':
      return isMobile.blackBerry();
    case 'iOS':
      return isMobile.iOS();
    case 'opera':
      return isMobile.opera();
    case 'windows':
      return isMobile.windows();
    case 'mobileOnly':
      return isMobile.android() || isMobile.blackBerry() || isMobile.iOSMobile() || isMobile.opera() || isMobile.windows();
    case 'all':
      return isMobile.android() || isMobile.blackBerry() || isMobile.iOS() || isMobile.opera() || isMobile.windows();
    default:
      break;
  }
}

function setLang() {
  // function getParameterByName(name, url) {
  //   if (!url) url = window.location.href;
  //   name = name.replace(/[\[\]]/g, "\\$&");
  //   var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
  //   results = regex.exec(url);
  //   if (!results) return null;
  //   if (!results[2]) return '';
  //   return decodeURIComponent(results[2].replace(/\+/g, " "));
  // }

  // const getLang = getParameterByName('lang');


  var getLang = location.pathname.substr(1, 3); // local site
  // const getLang = location.pathname.substr(17, 2);  // local site

  // const getLang = location.pathname.substr(12, 2); // live site

  // const getLang = location.pathname.substr(16, 2); // dev site
  var currentLang;

  switch (getLang) {
    case null:
      currentLang = 'en';
      document.documentElement.setAttribute('lang', 'en');
      return currentLang;
    case 'tc':
      currentLang = 'tc';
      document.documentElement.setAttribute('lang', 'zh-Hant');
      return currentLang;
    case 'sc':
      currentLang = 'sc';
      document.documentElement.setAttribute('lang', 'zh-Hans');
      return currentLang;
    default:
      currentLang = 'en';
      document.documentElement.setAttribute('lang', 'en');
      return currentLang;
      break;
  }
}

// function parsedData(entries) {
//   var moment = require('moment');
//
//   let data = {
//     data: [],
//   };
//
//   data = entries.map(data => ({
//     // event_end_ts: moment.unix(dataJuly.event_end_ts).format('hh:mma'),
//     event_start_ts: moment.unix(data.event_start_ts).format('hh:mma'),
//     event_start_date: moment.unix(data.event_start_ts).format('DD/M'),
//     event_ticket: data.event_ticket,
//     id: data.id,
//     total_booked: data.total_booked,
//   }));
//
//   return data;
// }

//return an array of objects according to key, value, or key and value matching
function getObjects(obj, key, val) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[i]) == 'object') {
      objects = objects.concat(getObjects(obj[i], key, val));
    } else
      //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
      if (i == key && obj[i] == val || i == key && val == '') {
        objects.push(obj);
      } else if (obj[i] == val && key == '') {
        //only add if the object is not already in the array
        if (objects.lastIndexOf(obj) == -1) {
          objects.push(obj);
        }
      }
  }
  return objects;
}
//return an array of values that match on a certain key
function getValues(obj, key) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[i]) == 'object') {
      objects = objects.concat(getValues(obj[i], key));
    } else if (i == key) {
      objects.push(obj[i]);
    }
  }
  return objects;
}

//return an array of keys that match on a certain value
function getKeys(obj, val) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[i]) == 'object') {
      objects = objects.concat(getKeys(obj[i], val));
    } else if (obj[i] == val) {
      objects.push(i);
    }
  }
  return objects;
}

var freezeAction = function freezeAction(e) {
  e.preventDefault();
};

function disableTouchMove(action) {
  if (action === true) {
    document.body.addEventListener('touchmove', freezeAction, false);
    // console.log('disable true');
  } else {
    document.body.removeEventListener('touchmove', freezeAction, false);
    // console.log('disable false');
  }
}

function detectIE() {
  // ie 6-11
  if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
    /* Microsoft Internet Explorer detected in. */
    //  console.log('ie');
    document.documentElement.classList.add('ie');
    return true;
  }
}

function iOSVersion() {
  var match = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/),
      version;

  if (match !== undefined && match !== null) {
    version = [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3] || 0, 10)];
    return parseFloat(version.join('.'));
  }
  return false;
}

function sortByDate(data) {
  var entries = data;

  // sort content by date
  entries.sort(function (a, b) {
    var itemA = a.dateID.replace(/[^A-Z0-9]+/ig, '');
    var itemB = b.dateID.replace(/[^A-Z0-9]+/ig, '');
    if (itemA < itemB) {
      return 1;
    }
    if (itemA > itemB) {
      return -1;
    }
    return 0;
  });

  return entries;
}



/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(176);
/* eslint-disable no-console */
/* eslint-disable no-var */
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
/* eslint-disable vars-on-top */
/* eslint-disable object-shorthand */
/* eslint-disable no-undef */
/* eslint-disable arrow-parens */
/* eslint-disable global-require */




// import home from '@/components/home';
// import articleView from '@/components/articleView';
// import notFound from '@/components/notFound';
// import tagResult from '@/components/tagResult';

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var home = function home(resolve) {
  __webpack_require__.e/* require.ensure */(0).then((function () {
    resolve(__webpack_require__(198));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var redirect = function redirect(resolve) {
  __webpack_require__.e/* require.ensure */(3).then((function () {
    resolve(__webpack_require__(200));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var notfound = function notfound(resolve) {
  __webpack_require__.e/* require.ensure */(2).then((function () {
    resolve(__webpack_require__(199));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var EventPage = function EventPage(resolve) {
  __webpack_require__.e/* require.ensure */(1).then((function () {
    resolve(__webpack_require__(197));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    // path: '/vd/staging/',
    path: '/',
    name: 'Home',
    component: home
  }, {
    // path: '/vd/staging/',
    path: '/en',
    name: 'HomeEn',
    component: home
  }, {
    // path: '/vd/staging/',
    path: '/tc',
    name: 'HomeTc',
    component: home
  }, {
    path: '/brandvideo',
    redirect: function redirect(to) {
      window.location.replace('https://www.facebook.com/victoriadockside/videos/1736693966365330');
    }
  }, {
    path: '/brandvideo/',
    redirect: function redirect(to) {
      window.location.replace('https://www.facebook.com/victoriadockside/videos/1736693966365330');
    }
  }, {
    path: '/video/',
    redirect: function redirect(to) {
      window.location.replace('https://www.facebook.com/victoriadockside/videos/1736693966365330');
    }
  }, {
    path: '/event/',
    name: 'EventPage',
    component: EventPage
  }, {
    path: '/en/event/',
    name: 'EventPageEn',
    component: EventPage
  }, {
    path: '/tc/event/',
    name: 'EventPageTc',
    component: EventPage
  }, {
    path: '*',
    name: 'notfound',
    component: notfound
  }]
}));

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animejs__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pp__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__json_data_json__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__json_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__json_data_json__);






var imagesLoaded = __webpack_require__(453);



// import data from './json/data_staging.json';


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    playsinline: true,
    showPressDate: false,
    scrolled: false,
    touchAllowed: false,
    menuAllowed: false,
    sliderBulletsAllowed: false,
    audioPlaying: false,
    openBox: false,
    contentTrigger: false,
    contentActive: false,
    nextPrevSectionClick: 0,
    interactionReady: false,
    data: __WEBPACK_IMPORTED_MODULE_7__json_data_json___default.a,
    timing: {
      contentTiming: 300,
      sectionTiming: 600,
      touchController: 400,
      touchThreshold: 100,
      resize: 100,
      animeOffset: '0',
      playButton: 200,
      closeContentDelay: 1200,
      closeActionDelay: 1000
    },
    strokeStatus: false,
    subContentActive: false,
    subContentMoveLeft: 0,
    closeContentActive: false,
    subContentVideoPlay: false,
    siteContainerValues: {
      offset: 0,
      currentSection: 0
    },
    subContentContainerValues: {
      offset: 0,
      currentSlide: 0
    },
    showSubContent: -1,
    menuActive: false,
    rotateValue: 90,
    bgValue: 0,
    s0: 0,
    s1: 0,
    s2: 0,
    s3: 0,
    s4: 0,
    s5: 0,
    s6: 0,
    size: {
      isDesktop: null,
      isTablet: null,
      isMobile: null
    },
    baseFontSize: null
  },
  mutations: {
    sectionClick: function sectionClick(state, status) {
      switch (status) {
        case 'next':
          state.nextPrevSectionClick += 1;
          break;
        case 'prev':
          state.nextPrevSectionClick -= 1;
          break;
        case 'reset':
          state.nextPrevSectionClick = 0;
          break;
        default:
          state.nextPrevSectionClick += 1;
          break;
      }
    },
    interactionReady: function interactionReady(state, value) {
      state.interactionReady = value;
    },
    sectionClickValue: function sectionClickValue(state, value) {
      state.nextPrevSectionClick = value;
    },
    strokeStatus: function strokeStatus(state, value) {
      state.strokeStatus = value;
    },
    audioPlaying: function audioPlaying(state, value) {
      state.audioPlaying = value;
    },
    sliderBulletsAllowed: function sliderBulletsAllowed(state, value) {
      state.sliderBulletsAllowed = value;
    },
    menuAllowed: function menuAllowed(state, value) {
      state.menuAllowed = value;
    },
    touchAllowed: function touchAllowed(state, value) {
      state.touchAllowed = value;
    },
    scrolled: function scrolled(state, value) {
      state.scrolled = value;
    },
    showPressDate: function showPressDate(state, value) {
      state.showPressDate = value;
    },
    checkMobileVideo: function checkMobileVideo(state, value) {
      state.playsinline = value;
    },
    subContentVideoPlay: function subContentVideoPlay(state, value) {
      state.subContentVideoPlay = value;
    },
    bgValue: function bgValue(state, value) {
      state.bgValue = value;
    },
    s0: function s0(state, value) {
      state.s0 = value;
    },
    s1: function s1(state, value) {
      state.s1 = value;
    },
    s2: function s2(state, value) {
      state.s2 = value;
    },
    s3: function s3(state, value) {
      state.s3 = value;
    },
    s4: function s4(state, value) {
      state.s4 = value;
    },
    s5: function s5(state, value) {
      state.s5 = value;
    },
    s6: function s6(state, value) {
      state.s6 = value;
    },
    menuActive: function menuActive(state, value) {
      state.menuActive = value;
    },
    showSubContent: function showSubContent(state, value) {
      state.showSubContent = value;
    },
    contentActive: function contentActive(state) {
      state.contentActive = true;
    },
    contentNotActive: function contentNotActive(state) {
      state.contentActive = false;
    },
    subContentActive: function subContentActive(state) {
      state.subContentActive = true;
    },
    subContentNotActive: function subContentNotActive(state) {
      state.subContentActive = false;
    },
    resetMoveLeft: function resetMoveLeft(state) {
      state.subContentMoveLeft = 0;
    },
    moveLeft: function moveLeft(state) {
      state.subContentMoveLeft -= window.innerWidth;
    },
    moveRight: function moveRight(state) {
      state.subContentMoveLeft += window.innerWidth;
    },
    goToSlide: function goToSlide(state, value) {
      state.subContentMoveLeft = -window.innerWidth * value;
    },
    setMoveLeftValue: function setMoveLeftValue(state, value) {
      state.subContentMoveLeft = value;
    },
    closeContentTrue: function closeContentTrue(state) {
      state.closeContentActive = true;
    },
    closeContentFalse: function closeContentFalse(state) {
      state.closeContentActive = false;
    },
    currentSlide: function currentSlide(state, slide) {
      state.subContentContainerValues.currentSlide = slide;
    },
    currentOffset: function currentOffset(state, offset) {
      state.subContentContainerValues.offset = offset;
    },
    currentMainSection: function currentMainSection(state, section) {
      state.siteContainerValues.currentSection = section;
    },
    currentMainOffset: function currentMainOffset(state, offset) {
      state.siteContainerValues.offset = offset;
    },
    currentMainOffsetSubtract: function currentMainOffsetSubtract(state, offset) {
      state.siteContainerValues.offset -= offset;
    },
    currentMainOffsetAdd: function currentMainOffsetAdd(state, offset) {
      state.siteContainerValues.offset += offset;
    }
  },
  actions: {
    refresh: function refresh() {
      window.location.reload(true);
    },
    checkSize: function checkSize(_ref) {
      var state = _ref.state;

      if (window.innerWidth > 992) {
        state.size.isDesktop = true;
        state.size.isTablet = false;
        state.size.isMobile = false;
        state.baseFontSize = 18;
      } else if (window.innerWidth <= 992 && window.innerWidth >= 768) {
        state.size.isDesktop = false;
        state.size.isTablet = true;
        state.size.isMobile = false;
        state.baseFontSize = 18;
      } else if (window.innerWidth < 768) {
        state.size.isDesktop = false;
        state.size.isTablet = false;
        state.size.isMobile = true;
        state.baseFontSize = 16;
      }
    },
    setFloatingButtonPos: function setFloatingButtonPos(context, baseFont) {
      var floatingButtonRight = document.querySelectorAll('.floating-button.is--right');
      var floatingButtonCenter = document.querySelectorAll('.floating-button.is--center');
      var fixPosRight = 15 / baseFont * baseFont;
      var sectionButtons = document.querySelectorAll('.go-to-section');

      for (var i = 0; i < floatingButtonRight.length; i += 1) {
        var buttonWidth = floatingButtonRight[i].offsetWidth;
        var leftPos = window.innerWidth - buttonWidth - fixPosRight;

        floatingButtonRight[i].style.left = leftPos + 'px';
      }

      for (var _i = 0; _i < floatingButtonCenter.length; _i += 1) {
        // const buttonWidth = floatingButtonCenter[i].offsetWidth;
        var centerPos = window.innerWidth / 2;

        floatingButtonCenter[_i].style.left = centerPos + 'px';
        // floatingButtonCenter[i].style.marginLeft = `-${buttonWidth / 2}px`;
      }

      for (var k = 0; k < sectionButtons.length; k += 1) {
        sectionButtons[k].style.top = window.innerHeight - 100 + 'px';
      }
    },
    applySizeSections: function applySizeSections(context) {
      var sectionContainer = document.querySelectorAll('.section__container');
      var sections = document.querySelectorAll('.section');
      var sectionWidth = window.innerWidth;
      var fullSections = document.querySelectorAll('.full-block');
      var menuContainer = document.querySelector('.menu__container');
      var videoContent = document.querySelectorAll('video');

      if (window.innerWidth < 767) {
        menuContainer.style.height = window.innerHeight + 'px';
        menuContainer.style.width = window.innerWidth + 'px';
      } else {
        menuContainer.style.height = 'auto';
        menuContainer.style.width = 'auto';
        // menuContainer.style.opacity = '1';
      }

      for (var i = 0; i < sections.length; i += 1) {
        var id = sectionContainer[i].getAttribute('data-id');
        var fullBlockSections = document.querySelectorAll('.section[data-id=\'' + id + '\'] .full-block');
        var childCount = fullBlockSections.length;
        var sectionOffset = sectionContainer[i].offsetTop;

        sections[i].style.height = window.innerHeight + 'px';
        sections[i].style.width = sectionWidth * childCount + 'px';
      }

      for (var ii = 0; ii < fullSections.length; ii += 1) {
        fullSections[ii].style.height = window.innerHeight + 'px';
        fullSections[ii].style.width = window.innerWidth + 'px';
      }

      for (var j = 0; j < videoContent.length; j += 1) {
        videoContent[j].style.minHeight = window.innerHeight + 'px';
        videoContent[j].style.minWidth = window.innerWidth + 'px';
      }
    },
    applyBgSize: function applyBgSize(context) {
      // NOTE: applyBgSize()
      var bgImages = document.querySelectorAll('.page-background__container img');

      imagesLoaded(bgImages, function () {
        for (var j = 0; j < bgImages.length; j += 1) {
          // console.log(j, bgImages[j].offsetWidth);
          if (window.innerWidth > 768 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isMobile */])('all')) {
            // bgImages[j].style.height = `${window.innerHeight}px`;
            // bgImages[j].classList.add('js-zoom'); disabled requested

            bgImages[j].style.height = window.innerHeight + 'px';
            bgImages[j].style.width = 'auto';
            bgImages[j].style.top = '0';

            // if (bgImages[j].offsetWidth < window.innerWidth) {
            //   bgImages[j].style.height = 'auto';
            //   bgImages[j].style.width = `${window.innerWidth}px`;
            // } else if (bgImages[j].offsetWidth >= window.innerWidth) {
            //   bgImages[j].style.height = `${window.innerHeight}px`;
            //   bgImages[j].style.width = 'auto';
            //   bgImages[j].style.top = '0';
            // }
          }

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isMobile */])('all')) {
            // setting image size for mobile
            if (window.innerWidth <= 768 && bgImages[j].parentNode.parentNode.getAttribute('class') !== 'cover-6') {
              // to fix some images that are width shorter when height is applied
              // console.log(bgImages[j], bgImages[j].offsetWidth / 2);
              if (bgImages[j].offsetWidth / 2 < window.innerWidth && bgImages[j].parentNode.parentNode.getAttribute('class') !== 'cover-2' && bgImages[j].parentNode.parentNode.getAttribute('class') !== 'cover-1' && bgImages[j].parentNode.parentNode.getAttribute('class') !== 'cover-4') {
                bgImages[j].style.width = window.innerWidth + 'px';
                bgImages[j].style.height = 'auto';
                bgImages[j].style.minHeight = 'auto';
              } else {
                bgImages[j].style.height = window.innerHeight + 'px';
                bgImages[j].style.width = 'auto';
                bgImages[j].style.minWidth = 'auto';
              }
            }

            // if (bgImages[j].offsetWidth > bgImages[j].offsetHeight) {
            //   bgImages[j].style.height = `${window.innerHeight}px`;
            //   bgImages[j].style.width = 'auto';
            //   bgImages[j].style.minWidth = 'auto';
            // } else {
            //   bgImages[j].style.width = `${window.innerWidth}px`;
            //   bgImages[j].style.height = 'auto';
            //   bgImages[j].style.minHeight = 'auto';
            // }

            if (bgImages[j].offsetWidth <= window.innerWidth && !bgImages[j].parentNode.classList.contains('has--video') || bgImages[j].parentNode.parentNode.getAttribute('class') === 'cover-6') {
              // bgImages[j].classList.add('js-zoom'); disabled requested
            } else if (bgImages[j].offsetWidth > window.innerWidth && !bgImages[j].parentNode.classList.contains('has--video') && !bgImages[j].classList.contains('js-zoom') && bgImages[j].parentNode.parentNode.getAttribute('class') !== 'cover-6') {
              if (window.innerWidth < 768) {
                if (bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-2' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-3' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-6' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-5-0') {
                  bgImages[j].classList.add('js-pan');
                  bgImages[j].style.height = window.innerHeight + 'px';
                  bgImages[j].style.width = 'auto';
                }
              } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                if (bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-2' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-3' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-6' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-5-0') {
                  // console.log(bgImages[j].parentNode.getAttribute('data-id'));
                  bgImages[j].classList.add('js-pan');
                  bgImages[j].style.height = window.innerHeight + 'px';
                  bgImages[j].style.width = 'auto';
                }
              }
            }
          }

          var leftValue = Math.abs((bgImages[j].offsetWidth - window.innerWidth) / 2);
          var topValue = Math.abs((bgImages[j].offsetHeight - window.innerHeight) / 2);

          if (bgImages[j].classList.contains('js-zoom')) {
            if (bgImages[j].offsetWidth >= window.innerWidth) {
              bgImages[j].style.left = 0;

              if (window.innerWidth >= 768) {
                // console.log(Math.abs((bgImages[j].offsetHeight - window.innerHeight) / 2));
                bgImages[j].style.top = Math.abs((bgImages[j].offsetHeight - window.innerHeight) / 2) + 'px';
              }
            } else {
              bgImages[j].style.left = leftValue + 'px';
            }

            if (window.innerWidth < 768) {
              bgImages[j].style.top = '0px';
            }
          }
        }
      });
    },

    applyResizeBgSize: __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(function (context) {
      /* NOTE: applyResizeBgSize() Resize for bg image
      [ ]
      */
      var bgImages = document.querySelectorAll('.page-background__container img');
      var activeBgImage = document.querySelector('.page-background__container .show img');

      imagesLoaded(bgImages, function () {
        for (var j = 0; j < bgImages.length; j += 1) {
          // console.log(j, bgImages[j].offsetWidth);
          if (window.innerWidth >= 768 && !bgImages[j].parentNode.classList.contains('has--video') && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isMobile */])('all')) {
            // bgImages[j].classList.add('js-zoom'); disabled requested
            bgImages[j].classList.remove('js-pan');
          }

          // if (bgImages[j].classList.contains('js-zoom')) {
          //   if (window.innerWidth >= 768) {
          //     if (bgImages[j].offsetWidth < window.innerWidth) {
          //       bgImages[j].style.height = 'auto';
          //       bgImages[j].style.width = `${window.innerWidth}px`;
          //     } else if (bgImages[j].offsetWidth > window.innerWidth) {
          //       bgImages[j].style.height = `${window.innerHeight}px`;
          //       bgImages[j].style.width = 'auto';
          //     }
          //     bgImages[j].style.top = '0';
          //   }
          // }

          var leftValue = Math.abs((bgImages[j].offsetWidth - window.innerWidth) / 2);
          var topValue = Math.abs((bgImages[j].offsetHeight - window.innerHeight) / 2);

          if (window.innerWidth >= 768) {
            if (bgImages[j].offsetWidth > window.innerWidth) {
              bgImages[j].style.left = '-' + leftValue + 'px';

              if (bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-2' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-6') {} else if (bgImages[j].parentNode.getAttribute('data-id') === 'cover-2-2' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isMobile */])('all') && window.innerWidth >= 768 && window.innerWidth < 1024) {
                bgImages[j].style.left = '-600px';
              } else if (bgImages[j].parentNode.getAttribute('data-id') === 'cover-2-6' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isMobile */])('all') && window.innerWidth >= 768 && window.innerWidth < 1024) {
                bgImages[j].style.left = '-700px';
              }
            } else {
              bgImages[j].style.left = leftValue + 'px';
            }
          }

          // setting mobile parameters
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isMobile */])('all')) {
            if (bgImages[j].offsetWidth <= window.innerWidth && !bgImages[j].parentNode.classList.contains('has--video') || bgImages[j].parentNode.parentNode.getAttribute('class') === 'cover-6') {
              // bgImages[j].classList.add('js-zoom'); disabled requested
              bgImages[j].classList.remove('js-pan');

              if (bgImages[j].offsetWidth > window.innerWidth) {
                bgImages[j].style.left = '-' + leftValue + 'px';
              } else {
                // bgImages[j].style.left = `${leftValue}px`;
                // bgImages[j].style.width = `${window.innerWidth}px`;
                // bgImages[j].style.height = 'auto';
                // bgImages[j].style.left = '0';
              }
            } else if (bgImages[j].offsetWidth > window.innerWidth && !bgImages[j].parentNode.classList.contains('has--video') && bgImages[j].parentNode.parentNode.getAttribute('data-id') !== 'cover-6') {

              if (window.innerWidth < 768) {
                if (bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-2' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-3' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-6' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-5-0') {
                  bgImages[j].classList.add('js-pan');
                  // bgImages[j].classList.remove('js-zoom'); disabled requested
                  bgImages[j].style.height = window.innerHeight + 'px';
                  bgImages[j].style.width = 'auto';
                  bgImages[j].style.transform = 'scale(1)';
                }
              } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                if (bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-2' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-3' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-2-6' && bgImages[j].parentNode.getAttribute('data-id') !== 'cover-5-0') {
                  // console.log(`jjj ${bgImages[j].parentNode.getAttribute('data-id')}`);
                  bgImages[j].classList.add('js-pan');
                  // bgImages[j].classList.remove('js-zoom'); disabled requested
                  bgImages[j].style.height = window.innerHeight + 'px';
                  bgImages[j].style.width = 'auto';
                  bgImages[j].style.transform = 'scale(1)';
                }
              }

              if (bgImages[j].classList.contains('js-pan')) {
                if (!bgImages[j].classList.contains('animate')) {
                  bgImages[j].style.left = '0';
                } else {
                  bgImages[j].style.left = '-' + leftValue + 'px';
                }
              }

              // if (bgImages[j].getAttribute('data-pan') === 'left-to-right' && !bgImages[j].classList.contains('animate')) {
              //   bgImages[j].style.left = '0';
              // } else if (bgImages[j].getAttribute('data-pan') === 'left-to-right' && bgImages[j].classList.contains('animate')) {
              //   const computedStyle = window.getComputedStyle(activeBgImage);
              //   bgImages[j].style.left = computedStyle.getPropertyValue('left');
              // } else {
              //   bgImages[j].style.left = 'auto';
              // }

              if (bgImages[j].getAttribute('data-pan') === 'right-to-left') {
                bgImages[j].style.left = 'auto';
              }
            }
          }
        }
      });
    }, 300),
    setFullBlockFloatingButtonPos: function setFullBlockFloatingButtonPos(context, baseFont) {
      var floatingButtonRight = document.querySelectorAll('.section__container.is--active .floating-button.is--right');
      var floatingButtonCenter = document.querySelectorAll('.section__container.is--active .floating-button.is--center');
      var fixPosRight = 15 / baseFont * baseFont;

      for (var i = 0; i < floatingButtonRight.length; i += 1) {
        var buttonWidth = floatingButtonRight[i].offsetWidth;
        var leftPos = window.innerWidth - buttonWidth - fixPosRight;

        floatingButtonRight[i].style.left = leftPos + 'px';
      }

      for (var _i2 = 0; _i2 < floatingButtonCenter.length; _i2 += 1) {
        var _buttonWidth = floatingButtonCenter[_i2].offsetWidth;
        var centerPos = window.innerWidth / 2;

        floatingButtonCenter[_i2].style.left = centerPos + 'px';
        // floatingButtonCenter[i].style.marginLeft = `-${buttonWidth / 2}px`;
      }
    },
    applySizeFullBlockSections: function applySizeFullBlockSections(context) {
      var sectionContainer = document.querySelector('.section__container.is--active');
      var section = document.querySelector('.section__container.is--active .section');
      var sectionWidth = window.innerWidth;
      var fullBlockSections = document.querySelectorAll('.section__container.is--active .section .full-block');
      var childCount = fullBlockSections.length;

      section.style.height = window.innerHeight + 'px';
      section.style.width = sectionWidth * childCount + 'px';

      for (var ii = 0; ii < fullBlockSections.length; ii += 1) {
        fullBlockSections[ii].style.height = window.innerHeight + 'px';
        fullBlockSections[ii].style.width = window.innerWidth + 'px';
      }
    },
    activeMenuItem: function activeMenuItem(context, index) {
      var item = document.querySelector('.menu__container li.is--active');
      var activeItem = document.querySelector('.menu__container li[data-index="' + index + '"]');

      item.classList.remove('is--active');
      activeItem.classList.add('is--active');
    },
    zoomEffect: function zoomEffect(context, status) {
      /* NOTE: zoomInEffect()
      [x] Apply zoom in from 95% - 100% (width)
      */
      var activeBgImage = document.querySelector('.page-background__container .show');
      var baseTiming = 15;
      var baseScale = 1000;
      var scale = 1.2;
      var duration = '' + baseTiming / baseScale * Math.round(window.innerWidth * scale);
      var isPlayed = activeBgImage.children[0].classList.contains('is--played');

      if (activeBgImage.children[0].classList.contains('js-zoom')) {
        activeBgImage.children[0].classList.add('animate');

        if (status) {
          // pause previous zoom element
          var mainImageClass = activeBgImage.parentNode.getAttribute('class');
          var mainImage = document.querySelector('.page-background__container [data-id=\'' + mainImageClass + '-0\']');

          if (mainImage.children[0].nodeName !== 'VIDEO') {
            if (document.querySelector('.page-background__container img.js-zoom--pause')) {
              var prevBgImage = document.querySelector('.page-background__container img.js-zoom--pause');
              var computedStyle = window.getComputedStyle(prevBgImage);
              var transformMatrix = computedStyle.getPropertyValue('transform');

              prevBgImage.style.transform = transformMatrix;
              prevBgImage.style.transitionDuration = '0s';
              prevBgImage.classList.remove('animate');
              prevBgImage.classList.remove('js-zoom--pause');
            }
          }

          // if pan is prev active bg, pause it
          if (document.querySelector('.page-background__container img.js-pause')) {
            var _prevBgImage = document.querySelector('.page-background__container img.js-pause');
            var prevPan = _prevBgImage.getAttribute('data-pan');
            var _computedStyle = window.getComputedStyle(_prevBgImage);

            if (prevPan === 'left-to-right') {
              var left = _computedStyle.getPropertyValue('left');
              _prevBgImage.style.left = left;
            } else if (prevPan === 'right-to-left') {
              var right = _computedStyle.getPropertyValue('right');
              _prevBgImage.style.right = right;
            }

            _prevBgImage.style.transitionDuration = '0s';
            _prevBgImage.classList.remove('animate');
            _prevBgImage.classList.remove('js-pause');
          }
        }

        activeBgImage.children[0].style.transitionDuration = duration + 's';
        activeBgImage.children[0].style.transform = 'scale(' + scale + ')';
      }
    },
    zoomEffectClose: function zoomEffectClose(_ref2, context) {
      var commit = _ref2.commit,
          state = _ref2.state;

      /* NOTE: zoomEffectClose()
      [x] Zoom out on close
      */
      var activeBgImage = document.querySelector('.page-background__container img.js-zoom.animate');
      var computedStyle = window.getComputedStyle(activeBgImage);
      var allZoomItems = document.querySelectorAll('.page-background__container .cover-' + state.siteContainerValues.currentSection + ' img.js-zoom');
      var mainBgImage = allZoomItems[0];
      var transformMatrix = computedStyle.getPropertyValue('transform');

      var baseTiming = 5;
      var baseScale = 1000;
      var scale = 1;
      var duration = '' + baseTiming / baseScale * Math.round(window.innerWidth * scale);

      // pause zoom on current active bg
      activeBgImage.style.transform = transformMatrix;

      // add zoom out effect on bg image if on first image
      if (mainBgImage.classList.contains('js-zoom') && mainBgImage.classList.contains('animate')) {
        activeBgImage.style.transitionDuration = duration + 's';
        activeBgImage.style.transitionTimingFunction = 'ease';
        activeBgImage.style.transform = 'scale(' + scale + ')';

        setTimeout(function () {
          activeBgImage.classList.remove('is--played');
          activeBgImage.style.transitionTimingFunction = 'linear';
          activeBgImage.style.transform = 'scale(1)';
          activeBgImage.style.transitionDuration = '0s';
          activeBgImage.classList.remove('animate');
        }, state.timing.closeContentDelay);

        // reset values for all other images
        for (var i = 1; i < allZoomItems.length; i += 1) {
          allZoomItems[i].classList.remove('is--played');
          allZoomItems[i].style.transitionDuration = '0s';
          allZoomItems[i].style.transform = 'scale(1)';
        }
      } else {
        activeBgImage.classList.remove('animate');

        setTimeout(function () {
          for (var _i3 = 1; _i3 < allZoomItems.length; _i3 += 1) {
            allZoomItems[_i3].classList.remove('is--played');
            allZoomItems[_i3].style.transform = 'scale(1)';
            allZoomItems[_i3].style.transitionDuration = '0s';
          }
        }, state.timing.closeContentDelay);

        // reset first image
        allZoomItems[0].style.transform = 'scale(1)';
        allZoomItems[0].style.transitionDuration = '0s';
      }
    },
    panEffect: function panEffect(context, status) {
      /* NOTE: panEffect() - for mobile
      [x] Pan from left to right
      [x] Pan from right to left
      [x] Calculate duration timing
      [x] Apply pan direction style
      [x] Stop panning when not in view
      */

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isMobile */])('all')) {
        var activeBgImage = document.querySelector('.page-background__container .show');
        var activePan = activeBgImage.children[0].getAttribute('data-pan');
        var distance = Math.round(activeBgImage.children[0].offsetWidth - window.innerWidth);
        var baseTiming = 30;
        var baseDistance = 1000;
        var timingDelay = 1;
        var updateDistance = '';
        var isPlayed = activeBgImage.children[0].classList.contains('is--played');

        if (activeBgImage.children[0].classList.contains('js-pan')) {
          activeBgImage.children[0].classList.add('animate');
        }

        if (status) {
          // pause previous pan element
          if (document.querySelector('.page-background__container img.js-pause')) {
            var prevBgImage = document.querySelector('.page-background__container img.js-pause');
            var prevPan = prevBgImage.getAttribute('data-pan');
            var computedStyle = window.getComputedStyle(prevBgImage);

            if (prevPan === 'left-to-right') {
              var left = computedStyle.getPropertyValue('left');
              prevBgImage.style.left = left;
            } else if (prevPan === 'right-to-left') {
              var right = computedStyle.getPropertyValue('right');
              prevBgImage.style.right = right;
            }

            prevBgImage.style.transitionDuration = '0s';
            prevBgImage.classList.remove('animate');
            prevBgImage.classList.remove('js-pause');
          }
        }

        // pause previous zoom element
        // if (document.querySelector('.page-background__container img.js-zoom--pause')) {
        //   const prevBgImage = document.querySelector('.page-background__container img.js-zoom--pause');
        //   const computedStyle = window.getComputedStyle(prevBgImage);
        //   const transformMatrix = computedStyle.getPropertyValue('transform');
        //
        //   prevBgImage.style.transform = transformMatrix;
        //   prevBgImage.style.transitionDuration = '0s';
        //   prevBgImage.classList.remove('animate');
        //   prevBgImage.classList.remove('js-zoom--pause');
        // }

        if (!isPlayed && activeBgImage.children[0].classList.contains('js-pan')) {
          activeBgImage.children[0].style.transitionDuration = baseTiming / baseDistance * distance + 's';
        } else if (isPlayed && activeBgImage.children[0].classList.contains('js-pan')) {
          if (activePan === 'left-to-right') {
            var pausedLeft = parseInt(activeBgImage.children[0].style.left);
            // console.log(pausedLeft);
            updateDistance = distance - Math.abs(parseInt(pausedLeft));
          } else if (activePan === 'right-to-left') {
            var pausedRight = parseInt(activeBgImage.children[0].style.right);
            // console.log(pausedRight);
            updateDistance = distance - Math.abs(parseInt(pausedRight));
          }
          activeBgImage.children[0].style.transitionDuration = baseTiming / baseDistance * distance / distance * updateDistance + 's';
        }
        // console.log(`duration: ${(baseTiming / baseDistance) * distance}s Base distance: ${distance} Actual Distance: ${updateDistance} Adjusted duration: ${(((baseTiming / baseDistance) * distance) / distance) * updateDistance}s`);

        if (activeBgImage.children[0].classList.contains('js-pan')) {
          if (activePan === 'left-to-right') {
            activeBgImage.children[0].style.left = '-' + distance + 'px';
          } else if (activePan === 'right-to-left') {
            activeBgImage.children[0].style.right = '-' + distance + 'px';
          }
        }

        if (activeBgImage.children[0].nodeName === 'VIDEO') {
          if (status) {
            // pause previous pan element
            if (document.querySelector('.page-background__container img.js-pause')) {
              var _prevBgImage2 = document.querySelector('.page-background__container img.js-pause');
              var _prevPan = _prevBgImage2.getAttribute('data-pan');
              var _computedStyle2 = window.getComputedStyle(_prevBgImage2);

              if (_prevPan === 'left-to-right') {
                var _left = _computedStyle2.getPropertyValue('left');
                _prevBgImage2.style.left = _left;
              } else if (_prevPan === 'right-to-left') {
                var _right = _computedStyle2.getPropertyValue('right');
                _prevBgImage2.style.right = _right;
              }

              _prevBgImage2.style.transitionDuration = '0s';
              _prevBgImage2.classList.remove('animate');
              _prevBgImage2.classList.remove('js-pause');
            }
          }
        }
      }
    },
    panEffectClose: function panEffectClose(_ref3, context) {
      var commit = _ref3.commit,
          state = _ref3.state;

      // NOTE: panEffectClose()
      var currentSlide = state.subContentContainerValues.currentSlide;
      var currentSection = state.siteContainerValues.currentSection;
      var activeBgImage = document.querySelector('.page-background__container [data-id="cover-' + currentSection + '-' + currentSlide + '"] img');
      var mainBgImage = document.querySelector('.page-background__container .show img');
      var allPanItems = document.querySelectorAll('.page-background__container .cover-' + state.siteContainerValues.currentSection + ' img.js-pan');

      // to reset main bg image
      if (mainBgImage.classList.contains('js-pan') && !mainBgImage.classList.contains('animate')) {
        if (mainBgImage.getAttribute('data-pan') === 'left-to-right') {
          mainBgImage.style.left = '0px';
        } else {
          mainBgImage.style.right = '0px';
        }
        mainBgImage.style.transitionDuration = '0s';
        mainBgImage.classList.remove('is--played');
      }

      // console.log(currentSlide, currentSection, activeBgImage, mainBgImage);

      if (activeBgImage.classList.contains('js-pan')) {
        var activePan = activeBgImage.getAttribute('data-pan');
        var computedStyle = window.getComputedStyle(activeBgImage);

        if (activePan === 'left-to-right') {
          var left = computedStyle.getPropertyValue('left');
          activeBgImage.style.left = left;
        } else if (activePan === 'right-to-left') {
          var right = computedStyle.getPropertyValue('right');
          activeBgImage.style.right = right;
        }

        activeBgImage.style.transitionDuration = '0s';
        activeBgImage.classList.remove('animate');

        setTimeout(function () {
          for (var i = 1; i < allPanItems.length; i += 1) {
            allPanItems[i].classList.remove('is--played');
            if (allPanItems[i].getAttribute('data-pan') === 'left-to-right') {
              allPanItems[i].style.left = '0px';
            } else {
              allPanItems[i].style.right = '0px';
            }
          }
        }, state.timing.closeContentDelay + 300);
      }
    },
    imageEffectResize: function imageEffectResize(_ref4, context) {
      var commit = _ref4.commit,
          state = _ref4.state;

      /* NOTE: imageEffectResize()
      [x] Stop zooming effect while resizing
      [x] Stop panning effect while resizing
      */
      var activeBgImage = document.querySelector('.page-background__container .show');
      var computedStyle = window.getComputedStyle(activeBgImage);

      if (activeBgImage.classList.contains('js-zoom')) {
        var transformMatrix = computedStyle.getPropertyValue('transform');
        var baseTiming = 5;
        var baseScale = 1000;
        var scale = 1;
        var duration = '' + baseTiming / baseScale * Math.round(window.innerWidth * scale);

        activeBgImage.style.transform = transformMatrix;
        activeBgImage.style.transitionDuration = '0s';
        activeBgImage.classList.remove('animate');
      } else if (activeBgImage.classList.contains('js-pan')) {
        var activePan = activeBgImage.getAttribute('data-pan');

        activeBgImage.classList.add('is--played');
        activeBgImage.style.transitionDuration = '0s';
        activeBgImage.classList.remove('animate');

        if (activePan === 'left-to-right') {
          var left = computedStyle.getPropertyValue('left');
          activeBgImage.style.left = left;
        } else if (activePan === 'right-to-left') {
          var right = computedStyle.getPropertyValue('right');
          activeBgImage.style.right = right;
        }
      }
    },
    stopAudio: function stopAudio(_ref5, context) {
      var commit = _ref5.commit,
          state = _ref5.state;

      // NOTE: stopAudio()
      var music = document.getElementById('bg-music');
      var soundButton = document.querySelector('.social__item.is--sound');

      commit('audioPlaying', false);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__pp__["d" /* stopMusic */])();

      soundButton.children[0].classList.remove('animate');

      __WEBPACK_IMPORTED_MODULE_3_animejs___default()({
        targets: soundButton,
        opacity: 0.3,
        easing: 'easeOutSine',
        duration: 200
      });
    },
    startAudio: function startAudio(_ref6, context) {
      var commit = _ref6.commit,
          state = _ref6.state;

      // NOTE: startAudio()
      var music = document.getElementById('bg-music');
      var soundButton = document.querySelector('.social__item.is--sound');

      commit('audioPlaying', true);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__pp__["e" /* startMusic */])();

      soundButton.children[0].classList.add('animate');

      __WEBPACK_IMPORTED_MODULE_3_animejs___default()({
        targets: soundButton,
        opacity: 1,
        easing: 'easeOutSine',
        duration: 200
      });
    },
    strokeZoom: function strokeZoom(_ref7, context) {
      var commit = _ref7.commit,
          state = _ref7.state;

      var strokeCanvas = document.getElementById('coverCanvas');

      if (!state.strokeStatus) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__pp__["f" /* enterCover */])();
        commit('strokeStatus', true);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__pp__["g" /* leaveCover */])();
        commit('strokeStatus', false);
      }
    },

    videoHandler: __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(function (_ref8, context) {
      var commit = _ref8.commit,
          state = _ref8.state;

      /* NOTE: videoHandler() main cover handler
      */

      if (state.playsinline) {
        var currentSection = state.siteContainerValues.currentSection;
        var activeVideo = document.querySelector('.page-background__container .cover-' + state.siteContainerValues.currentSection + ' video');

        if (document.querySelector('.cover-' + state.siteContainerValues.currentSection + ' .main-content-item').children[0].nodeName === 'VIDEO') {
          activeVideo.play();
        }
      }
    }, 500),
    getBgValue: function getBgValue(_ref9, value) {
      var commit = _ref9.commit,
          state = _ref9.state;

      switch (value) {
        case 0:
          commit('bgValue', state.s0);
          break;
        case 1:
          commit('bgValue', state.s1);
          break;
        case 2:
          commit('bgValue', state.s2);
          break;
        case 3:
          commit('bgValue', state.s3);
          break;
        case 4:
          commit('bgValue', state.s4);
          break;
        case 5:
          commit('bgValue', state.s5);
          break;
        case 6:
          commit('bgValue', state.s6);
          break;
        default:
          commit('bgValue', 0);
      }
    }
  }
}));

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(465),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expandCover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeCover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cover; });
/* unused harmony export enterSite */
/* unused harmony export setCutOffFreq */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return stopMusic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return startMusic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return enterCover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return leaveCover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_get_time__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_get_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_get_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_animejs__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__p__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(122);



// var moment = require('moment');


var TWEEN = __webpack_require__(201);
var requestAnimationFrame = __webpack_require__(460);
var THREE = __webpack_require__(463);
var Modernizr = __webpack_require__(220);
var Tone = __webpack_require__(464);





// Replace here
var coverCanvas, coverCtx;
var introCanvas, introCtx;
var partCanvas, partCtx;

var startT, now, t;
var mousePos, mousePosP;
var cover = new Object();

//_mode engine
var _mode = 0;
var _modeP = 0;

var v3;

var intro = true;
var checkCanvas;

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
	isTouch = Modernizr.touchevents;

	//$(window).scroll(checkScroll);
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).resize(checkResize);
	// $(window).mousemove(function(e) {
	// 	mouseMove(e.pageX,e.pageY);
	// });

	checkCanvas = setInterval(function () {
		var check = document.getElementById("coverCanvas");

		if (check) {
			initCoverCanvas();
			initIntroCanvas();
			initPartCanvas();

			initCover();

			// initThree();
			// initMotion();
			initLiquid();
			initPart();
			// initTouch();
			initLogoChar();

			render();
			checkResize();

			minifyCover(false);
			changeMode(1);

			clearInterval(checkCanvas);
		}
	}, 500);
});

//three
var camera;
var scene;
var planeGroup;
var renderer;
var plane;
var bgBalls;
var plane0;
var plane1;
var plane2;
var plane3;
var plane4;
var tex0;
var tex1;
var tex2;
var tex3;
var tex4;
//wave 3D scene setting
var currentWScene = -1;

//shader
//shader

//part
var liquid = new Array();
var unitW = 30;
var liquidW = Math.ceil(1200 / unitW); //1200
var liquidH = Math.ceil(670 / unitW); //670
var visc = 0.5;
var partSpeedMax = 20;
var historyMax = 8;
var partTotal = 0; //total particle spawned
//
var partSys = new Array();
var partMax = 250;
var partLife = 30;
var speedFactor = 1;
var wave = new Object();
wave.scaleFactor = 1;
wave.alpha = 1;

wave.swipeToAlpha = 0;
wave.waveAlpha = 0; //all wave
wave.partAlpha = 0;
wave.wave2Alpha = 0; //wave in logo positioin
wave.wave3Alpha = 0; //wave in i(s)
wave.vdLogoAlpha = 0;
wave.vdChar = new Array();
for (var i = 0; i < 16; i++) {
	var obj = new Object();
	obj.alpha = 0;
	//fade out
	obj.scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(0.5, 0.8);
	obj.dur = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(1500, 2000);

	obj.delay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(0, 1000);
	if (i == 1 || i == 6 || i == 13) {
		obj.delay = 1000;
	}
	//fade in
	obj.dur = 1000;
	obj.delay0 = 100 + i % 5 * 120 + i * 50;
	obj.angStart = 0;
	obj.angEnd = 0;
	//
	switch (i) {
		case 0:
			obj.maskType = 0;
			obj.offsetX = -25;
			obj.offsetY = -25;
			break;
		case 1:
			obj.maskType = 0;
			obj.offsetX = 12;
			obj.offsetY = -25;
			break;
		case 2:
			obj.maskType = 1;
			obj.offsetX = 0;
			obj.offsetY = 0;
		case 3:
			obj.maskType = 0;
			obj.offsetX = 25;
			obj.offsetY = 0;
			break;
		case 4:
			obj.maskType = 1;
			obj.offsetX = 0;
			obj.offsetY = 0;
			break;
		case 5:
			obj.maskType = 0;
			obj.offsetX = 0;
			obj.offsetY = 25;
			break;
		case 6:
			obj.maskType = 0;
			obj.offsetX = -12;
			obj.offsetY = 25;
			break;
		case 7:
			obj.maskType = 0;
			obj.offsetX = 0;
			obj.offsetY = 25;
			break;
		/////////////
		case 8:
			obj.maskType = 1;
			obj.offsetX = 0;
			obj.offsetY = 0;
			break;
		case 9:
			obj.maskType = 1;
			obj.offsetX = 0;
			obj.offsetY = 0;
			break;
		case 10:
			obj.maskType = 1;
			obj.offsetX = 0;
			obj.offsetY = 0;
			break;
		case 11:
			obj.maskType = 0;
			obj.offsetX = -25;
			obj.offsetY = 0;
			break;
		case 12:
			obj.maskType = 0;
			obj.offsetX = 25;
			obj.offsetY = 0;
			break;
		case 13:
			obj.maskType = 0;
			obj.offsetX = 12;
			obj.offsetY = -25;
			break;
		case 14:
			obj.maskType = 1;
			obj.offsetX = 0;
			obj.offsetY = 0;
			break;
		case 15:
			obj.maskType = 0;
			obj.offsetX = 25;
			obj.offsetY = 0;
			break;

		default:

	}

	wave.vdChar.push(obj);
}
wave.slantT = 0;
wave.t = 0;

//
var isStill = false;
var isTouch = false;
var hasMotion = false;
var forceX, forceY;
var tttMotion;

//part

function initThree() {
	camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 1, 100000);
	camera.position.z = 200;
	camera.position.y = 400;
	scene = new THREE.Scene();

	planeGroup = new THREE.Object3D();
	scene.add(planeGroup);

	//renderer = new THREE.WebGLRenderer({ antialias: true } );
	renderer = new THREE.WebGLRenderer();

	renderer.alpha = false;
	renderer.setClearColor(0x000000, 1);
	renderer.antialias = false;
	renderer.depth = false;
	renderer.setFaceCulling(false);
	renderer.sortObjects = false;
	renderer.setPixelRatio(window.devicePixelRatio);
	renderer.setSize(window.innerWidth, window.innerHeight);
	renderer.domElement.id = 'threeCanvas';
	document.getElementById('threeCanvasWrapper').appendChild(renderer.domElement);
	//
	//


	window.addEventListener('resize', onWindowResize, false);
}

function onWindowResize() {
	camera.aspect = window.innerWidth / window.innerHeight;
	camera.updateProjectionMatrix();
	renderer.setSize(window.innerWidth, window.innerHeight);
}

function initPart() {
	for (var i = 0; i < partMax; i++) {
		var obj = new Object();
		obj.id = i;
		obj.pos = new THREE.Vector2(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(0, 800), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(0, 800));
		obj.life = partLife + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(0, 50);
		obj.posHis = new Array();
		obj.posHisMax = historyMax;
		obj.isActive = false;
		obj.e1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(0.7, 0.9);
		obj.e2 = 1 - obj.e1;
		obj.speedMax = partSpeedMax;
		obj.rot = 0;
		var color = new THREE.Color("hsl(" + Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(0, 255)) + ", 100%, " + Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(0, 100)) + "%)");
		obj.strokeStyle = "#" + color.getHexString();
		obj.color;
		obj.cR;
		obj.cG;
		obj.cB;
		partSys.push(obj);
	}
}

function initTouch() {
	document.addEventListener('touchmove', function (e) {
		// e.preventDefault();
		mouseMove(e.targetTouches[0].pageX, e.targetTouches[0].pageY);
	}, false);
}

function initLiquid() {
	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {
			var obj = new Object();
			obj.force = new THREE.Vector2(0, 0);
			obj.force2 = new THREE.Vector2(0, 0); //for calculation
			obj.force3 = new THREE.Vector2(0, 0); //last legit force

			obj.alpha = 0;
			obj.rot = 0;

			obj.delayForce = new Array();
			for (var k = 0; k < 100; k++) {
				obj.delayForce.push(new THREE.Vector2(0, 0));
			}
			//obj.fX = ofRandom(-10,10);
			//obj.fY = ofRandom(-10,10);

			//obj.fX2 = 0;
			//obj.fY2 = 0;


			//			obj._x = i;
			//			obj._y = j;
			//			obj.x_1y_1 = liqGetIndex(i-1,j-1);
			//			obj.x0y_1 = liqGetIndex(i,j-1);
			//			obj.x1y_1 = liqGetIndex(i+1,j-1);
			//
			//			obj.x_1y0 = liqGetIndex(i-1,j);
			//			obj.xy0 = liqGetIndex(i,j);
			//			obj.x1y0 = liqGetIndex(i+1,j);
			//
			//			obj.x_1y1 = liqGetIndex(i-1,j+1);
			//			obj.x0y1 = liqGetIndex(i,j+1);
			//			obj.x1y1 = liqGetIndex(i+1,j+1);

			liquid.push(obj);
		}
	}
}

var logoCharList = new Array();

function initLogoChar() {
	var str = "VICTORIADOCKSIDE";
	var charList = str.split("");
	for (var i = 0; i < 16; i++) {
		var char = document.getElementById("vdLogo_" + charList[i] + "_ForCanvas");
		logoCharList.push(char);
	}
}

function initCoverCanvas() {
	coverCanvas = document.getElementById("coverCanvas");
	coverCtx = coverCanvas.getContext("2d");
	//
	// startT = moment();
	startT = __WEBPACK_IMPORTED_MODULE_1_date_fns_get_time___default()(new Date());
	//
	mousePos = new THREE.Vector2(0, 0);
	mousePosP = new THREE.Vector2(0, 0);
}

function initIntroCanvas() {
	introCanvas = document.getElementById("introCanvas");
	introCtx = coverCanvas.getContext("2d");
}

function initPartCanvas() {
	partCanvas = document.getElementById("partCanvas");
	partCtx = partCanvas.getContext("2d");
}

function initCover() {
	cover.scale = 10;
	cover.scale2 = 1;
	cover.isOn = false;
	cover.rotate = 0;
	cover.rotateT = 0.5;

	cover.update = function () {
		this.rotateT += 0.005;
		this.rotate = this.rotate * 0.9 + this.rotateT * 0.1;
	};
	cover.rotateTo = function (ang) {
		this.rotateT = ang / 180 * Math.PI;
	};
	cover.rotateBy = function (ang) {
		this.rotateT += ang / 180 * Math.PI;
	};
}

function initMotion() {

	if (window.DeviceMotionEvent != undefined && isTouch) {
		hasMotion = true;
		// console.log("has motion");

		window.ondevicemotion = function (event) {
			forceX = event.accelerationIncludingGravity.x;
			forceY = event.accelerationIncludingGravity.y;
			//console.log("Accelerometer data - x: " + event.accelerationIncludingGravity.x + " y: " + event.accelerationIncludingGravity.y + " z: " +event.accelerationIncludingGravity.z);

			//$('#status').html(ax);
		};
		tttMotion = setTimeout(function () {
			if (forceX == undefined) {
				//not a touch device
				hasMotion = false;
				clearTimeout(tttMotion);
			}
		}, 1000);
	} else {
		hasMotion = false;
		//console.log("no motion");
	}

	if (window.DeviceMotionEvent == undefined) {} else {}
}
//3d scene
function setWScene(n) {
	// setup THREE for scene


	clearWScene();
	currentWScene = n;

	// Reann edit THREE here

	if (n != -1) {
		switch (n) {
			case 0:
				tex0 = new THREE.Texture(partCanvas);
				tex0.needsUpdate = true;
				//tex0.wrapS = THREE.MirroredRepeatWrapping;
				tex0.wrapS = THREE.RepeatWrapping;

				tex0.wrapT = THREE.RepeatWrapping;
				tex0.offset.set(0.3, 0.3);
				tex0.repeat.set(4, 4);

				var geo0 = new THREE.PlaneGeometry(8000, 8000, 2, 2);
				var mat0 = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, map: tex0, transparent: true, blending: THREE.AdditiveBlending });
				plane0 = new THREE.Mesh(geo0, mat0);
				plane0.rotation.x = -Math.PI * 0.5;
				plane0.rotation.z = Math.PI * 0.1;
				plane0.position.z = -4000;
				planeGroup.add(plane0);
				plane0.position.z = 0;

				tex1 = new THREE.TextureLoader().load("static/threeScene/seaTex.jpg");
				var geo1 = new THREE.PlaneGeometry(8000, 8000, 2, 2);
				var mat1 = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, map: tex1, blending: THREE.NormalBlending });
				plane1 = new THREE.Mesh(geo1, mat1);
				plane1.rotation.x = -Math.PI * 0.5;
				plane1.position.z = -4000;
				planeGroup.add(plane1);
				plane1.position.z = 0;
				plane1.position.y = -20;

				tex4 = new THREE.TextureLoader().load("static/threeScene/cloud.png");
				//tex4.needsUpdate = true;
				tex4.wrapS = THREE.RepeatWrapping;
				tex4.wrapT = THREE.RepeatWrapping;
				tex4.offset.set(0.3, 0.3);
				tex4.repeat.set(4, 4);
				var geo4 = new THREE.PlaneGeometry(8000, 8000, 4, 4);
				var mat4 = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, map: tex4, transparent: true, blending: THREE.NormalBlending });
				plane4 = new THREE.Mesh(geo4, mat4);
				plane4.rotation.x = -Math.PI * 0.5;
				plane4.position.z = -4000;
				planeGroup.add(plane4);
				plane4.position.z = 0;
				plane4.position.y = 900;

				tex2 = new THREE.TextureLoader().load("static/threeScene/build0.png");
				var geo2 = new THREE.PlaneGeometry(512, 1024, 2, 2);
				var mat2 = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, map: tex2, transparent: true, premultipliedAlpha: true });
				plane2 = new THREE.Mesh(geo2, mat2);
				plane2.rotation.x = 0;
				planeGroup.add(plane2);
				plane2.position.z = -300;
				plane2.position.x = 300;
				plane2.position.y = 512 * 0.9;
				plane2.scale.set(0.9, 0.9, 1);

				tex3 = new THREE.TextureLoader().load("static/threeScene/background0.jpg");
				var geo3 = new THREE.PlaneGeometry(1024, 512, 2, 2);
				var mat3 = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, map: tex3 });
				plane3 = new THREE.Mesh(geo3, mat3);
				plane3.rotation.x = 0;
				planeGroup.add(plane3);
				plane3.position.z = -3000;
				plane3.position.x = 100;
				plane3.position.y = 256 * 8;
				plane3.scale.set(8, 8, 8);
				break;

			case 1:
				tex0 = new THREE.Texture(partCanvas);
				tex0.needsUpdate = true;
				tex0.wrapS = THREE.MirroredRepeatWrapping;
				tex0.wrapT = THREE.MirroredRepeatWrapping;
				tex0.offset.set(0.3, 0.3);
				tex0.repeat.set(4, 4);

				var geo0 = new THREE.PlaneGeometry(8000, 8000, 2, 2);
				var mat0 = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, map: tex0, transparent: true, blending: THREE.AdditiveBlending });
				plane0 = new THREE.Mesh(geo0, mat0);
				plane0.rotation.x = -Math.PI * 0.5;
				plane0.position.z = -4000;
				planeGroup.add(plane0);
				plane0.position.z = 0;

				tex1 = new THREE.TextureLoader().load("static/threeScene/background1.jpg");
				var geo1 = new THREE.PlaneGeometry(1024, 256, 2, 2);
				var mat1 = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, map: tex1, blending: THREE.NormalBlending });
				plane1 = new THREE.Mesh(geo1, mat1);
				plane1.rotation.x = 0;
				plane1.position.z = -20000;
				planeGroup.add(plane1);
				plane1.position.y = 128 * 50 + 2200;
				plane1.scale.set(50, 50, 1);

				tex2 = new THREE.TextureLoader().load("static/threeScene/dock.png");
				var geo2 = new THREE.PlaneGeometry(1024, 512, 2, 2);
				var mat2 = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, map: tex2, transparent: true, blending: THREE.NormalBlending });
				plane2 = new THREE.Mesh(geo2, mat2);
				plane2.rotation.x = 0;
				plane2.position.x = 300;
				plane2.position.z = -500;
				planeGroup.add(plane2);
				plane2.position.y = 256 * 1.2 - 50;
				plane2.scale.set(1.2, 1.2, 1);

				// tex3 = new THREE.TextureLoader().load("assets/images/threeScene/scene.jpg");
				// var geo3 = new THREE.PlaneGeometry(830,408, 2, 2);
				// var mat3 = new THREE.MeshBasicMaterial( { side: THREE.DoubleSide, map: tex3} );
				// plane3 = new THREE.Mesh(geo3, mat3);
				// plane3.rotation.x = 0;
				// planeGroup.add(plane3);
				// plane3.position.z = -4000;
				// plane3.position.x = 0;
				// plane3.position.y = 204*6;
				// plane3.scale.set(6,6,1);


				break;
		}
	}
}
function renderWScene(n) {
	switch (n) {
		case 0:
			var offset;
			var s;
			tex0.needsUpdate = true;
			offset = tex0.offset.x - 0.0002;
			tex0.offset.set(offset, offset);

			tex4.needsUpdate = true;
			offset = tex4.offset.x + 0.0008;
			tex4.offset.set(offset, -offset);

			//
			var windowRatio = window.innerWidth / window.innerHeight;
			plane2.position.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(windowRatio, 0.9, 2, 120, 550, false);
			//
			s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(windowRatio, 1, 2, 8, 10, false);
			plane3.scale.set(s, s, 1);
			plane3.position.y = 256 * s;
			//
			s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(windowRatio, 1, 2, 1, 1.5, false);
			plane1.scale.set(s, s, 1);
			break;
		case 1:
			tex0.needsUpdate = true;
			var offset;
			var s;
			var windowRatio = window.innerWidth / window.innerHeight;
			plane2.position.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(windowRatio, 1, 2, 300, 550, false);
			break;
	}
}
function clearWScene() {

	if (planeGroup) {
		while (planeGroup.children.length > 0) {
			planeGroup.remove(planeGroup.children[0]);
		}
	}
}

// init
function checkMode() {
	switch (_mode) {
		case 0:
			//default
			break;
		case 1:
			//
			break;
		case 10:
			//
			break;
		case 40:
			//
			break;

	}
}

//
//
//
//
//
//
//
//
//
//
//
//


function changeMode(i) {
	_modeP = _mode;
	_mode = i;
	if (_mode != _modeP) {
		switch (_mode) {
			case 0:
				break;
			case 1:
				// wait for swipe
				//wave.tween = new TWEEN.Tween(wave).to({t:10},10000).start();

				// wave.tween = new TWEEN.Tween(wave).to({vdLogoAlpha:1},1000).start();
				for (var i = 0; i < 16; i++) {
					// 	wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({alpha:1},1000).delay(0).start();
					wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({ alpha: 1 }, wave.vdChar[i].dur).delay(wave.vdChar[i].delay0).start();
					wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({ scale: 0.75 }, wave.vdChar[i].dur).delay(wave.vdChar[i].delay0).easing(TWEEN.Easing.Quintic.Out).start();
					wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({ offsetX: 0 }, wave.vdChar[i].dur).delay(wave.vdChar[i].delay0).easing(TWEEN.Easing.Quintic.Out).start();
					wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({ offsetY: 0 }, wave.vdChar[i].dur).delay(wave.vdChar[i].delay0).easing(TWEEN.Easing.Quintic.Out).start();

					wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({ angEnd: Math.PI * 2 }, wave.vdChar[i].dur).delay(wave.vdChar[i].delay0).easing(TWEEN.Easing.Quintic.Out).start();
				}
				wave.tween = new TWEEN.Tween(wave).to({ waveAlpha: 1 }, 800).delay(1100).start();
				//wave.tween2 = new TWEEN.Tween(wave).to({logoAlpha:1},2000).delay(1000).start();
				var ttt = setTimeout(function () {
					changeMode(10);
				}, 5000);

				break;
			case 2:
				// fade in waves, fade out swipe, fade in logo, and delay to enter
				// wave.tween = new TWEEN.Tween(wave).to({swipeToAlpha:0},1000).start();
				// wave.tween = new TWEEN.Tween(wave).to({waveAlpha:1},500).start();
				// wave.tween = new TWEEN.Tween(wave).to({wave3Alpha:1},1000).delay(2000).start();
				// wave.tween = new TWEEN.Tween(wave).to({partAlpha:0},1000).start();

				//wave.tween = new TWEEN.Tween(wave).to({vdLogoAlpha:0},1000).delay(100).start();


				//wave.vdCharDelay = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
				//wave.vdCharAlpha = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];


				// var ttt = setTimeout(function(){changeMode(10);} ,10000000);//4000
				break;
			case 10:
				// fade out waves, according to how close to the i, 3i left
				wave.tween = new TWEEN.Tween(wave).to({ waveAlpha: 0 }, 500).start(); // handle in render()
				// wave.tween = new TWEEN.Tween(wave).to({vdLogoAlpha:0},1000).delay(2000).start();
				wave.tween = new TWEEN.Tween(wave).to({ slantT: 1 }, 2000).delay(100).start();

				for (var i = 0; i < 16; i++) {
					wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({ alpha: 0 }, wave.vdChar[i].dur).delay(wave.vdChar[i].delay).start();
					wave.tween = new TWEEN.Tween(wave.vdChar[i]).to({ scale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(0.5, 1) }, wave.vdChar[i].dur).delay(wave.vdChar[i].delay).start();
				}

				var ttt = setTimeout(function () {
					changeMode(40);
				}, 4000);

				break;
			// case 20:// fade 3 i
			// 		//wave.tween = new TWEEN.Tween(wave).to({waveAlpha:0},500).start();// handle in render()
			// 		wave.tween = new TWEEN.Tween(wave).to({wave3Alpha:0},1000).start();
			//
			// 		var ttt = setTimeout(function(){changeMode(40);} ,1000);
			// 		break;

			case 40:
				//
				wave.tween = new TWEEN.Tween(wave).to({ scaleFactor: 1.2 }, 3000).easing(TWEEN.Easing.Quintic.Out).start();
				//wave.tween = new TWEEN.Tween(wave).to({partAlpha:1},1000).start();
				cover.rotate = 1.7;
				cover.rotateT = 1.7;
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#partCanvas').fadeOut(2000);
				closeCover(true);
				//enter site here
				var header = document.querySelector('.header');
				var menuContainer = document.querySelector('.menu__container');
				var siteContainer = document.getElementById('site-content__container');
				var allButtons = document.querySelectorAll('button');
				var social = document.querySelector('.social__container');

				for (var _i = 0; _i < allButtons.length; _i += 1) {
					allButtons[_i].disabled = false;
				}

				setTimeout(function () {
					menuContainer.style.zIndex = '98';
					social.style.zIndex = '98';
					intro = false;
				}, 1000);

				document.querySelector('.page-background__container .cover-0 video').play();

				if (window.innerWidth >= 768) {
					__WEBPACK_IMPORTED_MODULE_2_animejs___default()({
						targets: [header, menuContainer, siteContainer, menuContainer.children[0], social],
						opacity: 1,
						easing: 'easeOutSine',
						duration: 300,
						delay: 1000
					});
				} else {
					__WEBPACK_IMPORTED_MODULE_2_animejs___default()({
						targets: [header, menuContainer, siteContainer],
						opacity: 1,
						easing: 'easeOutSine',
						duration: 300,
						delay: 1000
					});
				}

				if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* isMobile */])('all')) {
					startMusic();
				}

				// console.log('case 40');
				break;
			case 50:
				//
				// $('#threeCanvasWrapper').show();
				partCanvas.width = 1024;
				partCanvas.height = 1024;
				wave.scaleFactor = 1;
				wave.waveAlpha = 1;
				wave.wave2Alpha = 1;

				break;

		}
	}
}

function drawCover() {

	coverCtx.fillStyle = "#000";
	//coverCtx.fillRect(0,0,coverCanvas.width, coverCanvas.height);

	coverCtx.beginPath();
	coverCtx.moveTo(0, 0);
	coverCtx.lineTo(coverCanvas.width, 0);
	coverCtx.lineTo(coverCanvas.width, coverCanvas.height);
	coverCtx.lineTo(0, coverCanvas.height);
	coverCtx.lineTo(0, 0);
	coverCtx.closePath();

	var m = cover.scale;
	var hoverFeedback = cover.scale2;
	var slantW = 340 * m * hoverFeedback;
	var slantH = 84 * m * hoverFeedback;

	coverCtx.save();
	coverCtx.translate(coverCanvas.width / 2, coverCanvas.height / 2);
	//coverCtx.rotate(t*0.0005);
	coverCtx.rotate(cover.rotate);
	coverCtx.translate(-slantW / 2, -slantH / 2);
	coverCtx.moveTo(0, 0);
	coverCtx.lineTo(0, slantH);
	coverCtx.lineTo(slantW, slantH);
	coverCtx.lineTo(slantW, 0);
	coverCtx.lineTo(0, 0);
	coverCtx.closePath();

	coverCtx.restore();

	coverCtx.fill();
}

function updateLiquid() {
	var v1 = visc;
	var v2 = (1 - v1) / 2;

	var comp1 = 0.20710678118654754; //component 1, 1/(0.707*4+2)
	var comp2 = 0.14644660940672627; //component 2, 0.707/(0.707*4+2)


	//reset
	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {
			var obj = liquid[i + j * liquidW];
			obj.force2.set(0, 0);
		}
	}

	// delay force
	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {
			var obj = liquid[i + j * liquidW];
			obj.force2.x += obj.delayForce[0].x;
			obj.force2.y += obj.delayForce[0].y;

			var pos = new THREE.Vector2(0, 0);
			obj.delayForce.unshift(pos);
			var posLast = obj.delayForce.pop();
			obj.force2.x += posLast.x;
			obj.force2.y += posLast.y;
		}
	}

	//

	//

	//average force
	for (var j = 1; j < liquidH - 1; j++) {
		for (var i = 1; i < liquidW - 1; i++) {
			var obj0 = liquid[i + j * liquidW];
			var objW = liquid[i - 1 + j * liquidW];
			var objE = liquid[i + 1 + j * liquidW];

			var objNW = liquid[i - 1 + (j - 1) * liquidW];
			var objNE = liquid[i + 1 + (j - 1) * liquidW];

			var objSW = liquid[i - 1 + (j + 1) * liquidW];
			var objSE = liquid[i + 1 + (j + 1) * liquidW];

			v1 = visc + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(-0.05, 0.05);
			//v1 = visc;
			v2 = (1 - v1) * comp1;
			v3 = (1 - v1) * comp2;

			obj0.force2.x += (obj0.force.x * v1 + (objW.force.x + objE.force.x) * v2 + (objNW.force.x + objNE.force.x + objSW.force.x + objSE.force.x) * v3) * 1;
		}
	}

	for (var i = 1; i < liquidW - 1; i++) {
		for (var j = 1; j < liquidH - 1; j++) {
			var obj0 = liquid[i + j * liquidW];
			var objN = liquid[i + (j - 1) * liquidW];
			var objS = liquid[i + (j + 1) * liquidW];

			var objNW = liquid[i - 1 + (j - 1) * liquidW];
			var objSW = liquid[i - 1 + (j + 1) * liquidW];

			var objNE = liquid[i + 1 + (j - 1) * liquidW];
			var objSE = liquid[i + 1 + (j + 1) * liquidW];

			v1 = visc + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(-0.05, 0.05);
			//v1 = visc;
			v2 = (1 - v1) * comp1;
			v3 = (1 - v1) * comp2;

			//obj0.force2.y += (obj0.force.y *v1 + objN.force.y *v2 + objS.force.y * v2) *1;
			obj0.force2.y += (obj0.force.y * v1 + (objN.force.y + objS.force.y) * v2 + (objNW.force.y + objSW.force.y + objNE.force.y + objSE.force.y) * v3) * 1;
		}
	}

	// bounce on border
	//	for (var j = 1; j <liquidH - 1; j++) {
	//		var i = 1;
	//		var i2 = 2;
	//			var obj0 = liquid[i +j * liquidW];
	//			var obj1 = liquid[i2 +j * liquidW];
	//
	//			//if(obj0.force.x <0){
	//				obj1.delayForce[0].x = obj0.force.x*-1;
	//				obj1.delayForce[0].y = obj0.force.y*1;
	//
	//				obj1.delayForce[0].clampLength(-10,10);
	//
	//			//}
	//
	//			//obj0.force2.x += (obj0.delayForce[0].x );
	//	}

	// merge force2 to force
	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {
			var obj = liquid[i + j * liquidW];
			if (obj.force2.length() > 0.005) {
				obj.force.copy(obj.force2);
				obj.force3.copy(obj.force);
			} else {
				obj.force.copy(obj.force3);
			}
		}
	}
}

function updatePart() {
	for (var i = 0; i < partMax; i++) {
		var obj = partSys[i];
		if (obj.isActive) {

			var lX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["c" /* ofClamp */])(Math.floor(obj.pos.x / unitW), 1, 38);
			var lY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["c" /* ofClamp */])(Math.floor(obj.pos.y / unitW), 1, 38);
			var ind0 = lX + lY * liquidW;

			if (ind0 >= 0 && ind0 < liquidW * liquidH) {

				var vX = obj.pos.x * -obj.e2 + (obj.pos.x + liquid[ind0].force.x * 4) * obj.e2;

				var vY = obj.pos.y * -obj.e2 + (obj.pos.y + liquid[ind0].force.y * 4) * obj.e2;

				var vXY = new THREE.Vector2(vX, vY);
				vXY.clampLength(0.05, obj.speedMax);

				obj.pos.add(vXY);

				//obj.pos.x = obj.pos.x*obj.e1   +   (obj.pos.x+liquid[ind0].force.x*4) *obj.e2;
				//obj.pos.y = obj.pos.y*obj.e1   +   (obj.pos.y+liquid[ind0].force.y*4) *obj.e2;


				//history

				var pos = new THREE.Vector2();
				pos.copy(obj.pos);
				obj.posHis.unshift(pos);
				while (obj.posHis.length > obj.posHisMax) {
					obj.posHis.pop();
				}

				//handle life
				obj.life--;
				if (obj.life < 0) {
					obj.isActive = false;
				}

				//outbound
				if (obj.pos.x < unitW || obj.pos.x > unitW * liquidW - unitW || obj.pos.y < unitW || obj.pos.y > unitW * liquidH - unitW) {

					obj.isActive = false;
					obj.life = 0;
				}
			}
		}
		//
	}
}

//*********************************************************************

// Render

//*********************************************************************
function render(time) {
	// now = moment();
	now = __WEBPACK_IMPORTED_MODULE_1_date_fns_get_time___default()(new Date());
	t = now - startT;
	//
	if (intro) {
		updateLiquid();
		updatePart();
	}

	TWEEN.update(time);

	cover.update();
	//
	coverCtx.clearRect(0, 0, coverCanvas.width, coverCanvas.height);

	if (intro) {
		drawPart();
	}
	drawCover();
	//
	//
	if (currentWScene != -1) {
		renderWScene(currentWScene);
		renderer.render(scene, camera);
		// console.log(1);
		//parallex
		// if(hasMotion){
		//   if( !isNaN(planeGroup.rotation.y) ){
		//     planeGroup.rotation.y = planeGroup.rotation.y*0.9 -  0.03*forceX*0.1;
		//   }else{
		//     planeGroup.rotation.y = 0;
		//   }
		//   //planeGroup.rotation.y = 0.03*forceX;
		// }else{
		//   planeGroup.rotation.y = -(mousePos.x-  window.innerWidth*0.5)/( window.innerWidth*0.5)* 0.03;
		// }
	}
	requestAnimationFrame(render);
}

function drawPart() {

	var ctx = partCtx;

	ctx.clearRect(0, 0, partCanvas.width, partCanvas.height);
	ctx.fillStyle = "#000";

	//var liquidW = Math.ceil(1200/unitW);//1200
	// var liquidH = Math.ceil(670/unitW);//670

	var _s0 = window.innerWidth / 1200;
	var _s1 = window.innerHeight / 670;
	var _s = Math.max(_s0, _s1);
	var newW = 1200 * _s;
	var newH = 670 * _s;
	var _x = (window.innerWidth - newW) * 0.5;
	var _y = (window.innerHeight - newH) * 0.5;

	var logoStartCol = Math.floor(liquidW * 0.5) - 4;
	var logoEndCol = Math.floor(liquidW * 0.5) + 4;
	var logoStartRow = Math.floor(liquidH * 0.5) - 1;
	var logoEndRow = Math.floor(liquidH * 0.5) + 1;

	ctx.save();
	ctx.translate(window.innerWidth * 0.5, window.innerHeight * 0.5);
	ctx.scale(wave.scaleFactor, wave.scaleFactor);
	//if(wave.scaleFactor==1){
	ctx.translate(-window.innerWidth * 0.5, -window.innerHeight * 0.5);
	//}else {
	//	ctx.translate(-window.innerWidth*0.5+77,-window.innerHeight*0.5+45);
	//}


	ctx.translate(_x, _y);
	ctx.scale(_s, _s);

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	//ctx.fillRect(0, 0, partCanvas.width, partCanvas.height);
	var pace = 0.5 * Math.sin(t * 0.001 * 0.1);
	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {

			var obj = liquid[i + j * liquidW];
			var force = obj.force;
			var ang = force.angle();
			var mag = force.length();
			var _a;

			// the 3 I
			var di1, di2, di3;
			var _dx, _dy;

			_dx = i - (logoStartCol + 1);
			_dy = j - logoStartRow;
			di1 = Math.sqrt(_dx * _dx + _dy * _dy);
			//if(j>logoStartRow)di1 = 10;

			_dx = i - (logoStartCol + 6);
			_dy = j - logoStartRow;
			di2 = Math.sqrt(_dx * _dx + _dy * _dy);
			//if(j>logoStartRow)di1 = 10;

			_dx = i - (logoStartCol + 5);
			_dy = j - (logoStartRow + 1);
			di3 = Math.sqrt(_dx * _dx + _dy * _dy);
			//if(j<=logoStartRow)di1 = 10;


			//if(_mode == 10){
			var dMin = Math.min(di1, di2, di3);
			//console.log(di1+"/"+di2+"/"+di3);
			//}
			if (i >= logoStartCol && i < logoEndCol && j >= logoStartRow && j < logoEndRow) {
				// logo position


				_a = wave.wave2Alpha;
			} else {
				//others
				//if mode is 10, a
				if (_mode == 10) {
					// use custom calculation to decrease obj.alpha
					_a = obj.alpha - (Math.pow(2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(dMin, -2, 15, 0, 0.4, true)) - 1) * 0.25;
					_a = Math.max(_a, 0);
				} else {
					_a = wave.waveAlpha;
				}
			}

			obj.alpha = _a;
			//draw line

			ctx.save();

			//var _a = obj.alpha;

			ctx.globalAlpha = _a;
			ctx.fillStyle = "#FFF";

			ctx.translate((i + 0.5) * unitW, (j + 0.5) * unitW);

			var _rot = 0;

			//
			//
			// wave and wake here
			//
			//
			//

			//var tt = t*0.0008-i*0.05-j*0.02*Math.sin(j*0.05+t*0.001+3);
			var tt = t * 0.0008 - i * 0.05 - j * 0.05;
			var _v = new THREE.Vector2(i - 7, j - 7);
			var d = _v.length();
			tt = t * 0.0013 - d * 0.1 + 100 - 1;

			// wave speed
			//tt *= 2;
			tt *= 0.5;

			var wake = Math.sin(tt) + 1 / 3 * Math.sin(tt * 3 + 0.2) + 1 / 5 * Math.sin(tt * 5);
			var tt2 = 0.4 + t * 0.0009 + i * 0.05 - j * 0.02;
			var wake2 = Math.sin(tt2) + 1 / 3 * Math.sin(tt2 * 3) + 1 / 5 * Math.sin(tt2 * 5) + 1 / 7 * Math.sin(tt2 * 7) + 1 / 9 * Math.sin(tt2 * 9);

			speedFactor = 0;
			//var _rot = ang-Math.PI*0.5 + mag*0.001  + (0.3*Math.PI*Math.sin(i*0.19+t*0.0005+4)+0.3*Math.PI*Math.cos(j*0.19+t*0.0006+2)+t*0.001)*speedFactor ;

			// double wave
			//_rot = wake*2 + wake2*0.8;

			// single save
			_rot = wake * 2;

			// add turbulence here
			if (_mode == 50) {
				_rot += 0.3 * Math.PI * Math.sin(i * 0.12 + 4) + 0.3 * Math.PI * Math.cos(j * 0.12 + 2) + t * 0.001;
			}
			_rot = obj.rot + (_rot + 100 * Math.PI) % (2 * Math.PI);

			//obj.rot = _rot;

			if (_mode == 10) {
				ctx.rotate(_rot * (1 - wave.slantT) + 3.6 * wave.slantT);
			} else {
				ctx.rotate(_rot);
			}

			ctx.translate(0, -20 * 0.5);

			ctx.fillRect(0, 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(Math.sin(_rot * 2 + 1), -1, 1, 1, 4, true), 20);

			//ctx.fillRect(0, 0, 4, 20);
			ctx.globalAlpha = 1;

			ctx.restore();

			// slowly unveil
			//obj.alpha += Math.abs(0.01*Math.sin(i*0.5+t*0.0005) +  0.01*Math.cos(j*0.5+t*0.0006) );
		}
	}

	var _a = wave.partAlpha;
	ctx.globalAlpha = _a;
	for (var i = 0; i < partMax; i++) {
		var obj = partSys[i];
		if (obj.isActive) {
			//ctx.strokeStyle = "#F05";
			ctx.strokeStyle = obj.strokeStyle;
			ctx.lineWidth = 1;

			ctx.beginPath();
			var pos = new THREE.Vector2(0, 0);

			// make line visible
			// if(obj.posHis.length >0){
			// 	var liqID = Math.floor(obj.posHis[0].x/unitW) + Math.floor(obj.posHis[0].y/unitW) * liquidW;
			// 	if(liqID < liquid.length){
			// 		var liq = liquid[liqID];
			// 		//console.log(Math.floor(pos.x/unitW) + Math.floor(pos.y/unitW) * liquidW );
			// 		liq.brightness = 255;
			// 		//
			// 	}
			// }

			for (var j = 0; j < obj.posHis.length; j++) {
				if (j == 0) {
					//ctx.moveTo(obj.posHis[j].x, obj.posHis[j].y);
					pos.copy(obj.posHis[j]);
					ctx.moveTo(pos.x, pos.y);
				} else {
					pos.x = pos.x * 0.9 + obj.posHis[j].x * 0.1;
					pos.y = pos.y * 0.9 + obj.posHis[j].y * 0.1;

					//pos.x = obj.posHis[j].x;
					//pos.y = obj.posHis[j].y;


					ctx.lineTo(pos.x, pos.y);
					//ctx.lineTo(obj.posHis[j].x, obj.posHis[j].y);
				}
			}

			ctx.stroke();
		}

		// if(partTotal>500 && _mode == 1){
		// 	changeMode(2);
		// }
	}

	ctx.globalAlpha = 1;

	//draw intruction
	ctx.globalAlpha = wave.swipeToAlpha;
	var img = document.getElementById("swipeToForCanvas");
	if (img.width > 0) {

		//ctx.drawImage(img,0,0);
		ctx.drawImage(img, 1200 * 0.5 - img.width * 0.5, 670 * 0.5 - img.height * 0.5);
	}

	ctx.globalAlpha = 1;
	//draw instruction

	//draw logo
	for (var i = 0; i < logoCharList.length; i++) {
		var char = logoCharList[i];

		if (char.width > 0) {
			var _a = wave.vdChar[i].alpha;
			var _s = wave.vdChar[i].scale;
			var offsetX = wave.vdChar[i].offsetX;
			var offsetY = wave.vdChar[i].offsetY;
			var maskType = wave.vdChar[i].maskType;
			var angEnd = wave.vdChar[i].angEnd;
			var angStart = wave.vdChar[i].angStart;

			var angOffset = -Math.PI * 0.5;

			var _x = logoStartCol * unitW + (i % 8 + 0.5) * unitW;
			var _y = logoStartRow * unitW + (Math.floor(i / 8) + 0.5) * unitW;
			var r = 25;

			ctx.globalAlpha = _a;
			ctx.save();
			if (maskType == 0) {
				ctx.rect(_x - 22, _y - 22, 44, 44);
			} else {
				//1
				ctx.beginPath();
				ctx.moveTo(_x, _y);
				//ctx.lineTo();
				ctx.arc(_x, _y, r, angStart + angOffset, angEnd + angOffset, false);
				ctx.lineTo(_x, _y);
			}
			//clipping

			ctx.clip();
			//clipping
			ctx.translate(_x + offsetX, _y + offsetY);
			ctx.scale(_s, _s);
			ctx.drawImage(char, -22, -22, 44, 44);
			ctx.globalAlpha = 1;
			ctx.restore();
		}
	}
	//
	// var img=document.getElementById("vdLogoForCanvas");
	// if(img.width >0){
	// 	ctx.globalAlpha = wave.vdLogoAlpha;
	// 	ctx.drawImage(img,(logoStartCol)*unitW,(logoStartRow)*unitW);
	// 	ctx.globalAlpha = 1;
	// }
	//draw logo


	ctx.restore();
}

function drawPartImageData() {

	var ctx = partCtx;

	var canvasData = ctx.getImageData(0, 0, canvasIntro.width, canvasIntro.height);
	for (var i = 0; i < partMax; i++) {
		var obj = partSys[i];
		if (obj.isActive) {

			var pos = new THREE.Vector2(0, 0);
			for (var j = 0; j < obj.posHis.length; j++) {
				if (j == 0) {
					//ctx.moveTo(obj.posHis[j].x, obj.posHis[j].y);
					pos.copy(obj.posHis[j]);
					//ctx.moveTo(pos.x,pos.y);

					drawPixel(canvasData, Math.floor(pos.x), Math.floor(pos.y), obj.cR, obj.cG, obj.cB, 255);
					//drawPixel(canvasData,Math.floor(pos.x)+1, Math.floor(pos.y), obj.cR, obj.cG, obj.cB, 255);
					//drawPixel(canvasData,Math.floor(pos.x)+1, Math.floor(pos.y)+1, obj.cR, obj.cG, obj.cB, 255);
					//drawPixel(canvasData,Math.floor(pos.x), Math.floor(pos.y)+1, obj.cR, obj.cG, obj.cB, 255);

				}
			}
		}
	}
	ctx.putImageData(canvasData, 0, 0);
}

function mouseMove(x, y) {

	//mapping fullscreen to 1200 x 670
	x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(x, 0, window.innerWidth, 0, 1200, true);
	y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(y, 0, window.innerHeight, 0, 670, true);

	var mouseX = x;
	var mouseY = y;
	mousePosP.copy(mousePos);
	mousePos.set(mouseX, mouseY);

	//
	//check mouse over
	var dM = new THREE.Vector2();
	dM.subVectors(mousePos, mousePosP).multiplyScalar(2);
	var lX = Math.floor(mouseX / unitW);
	var lY = Math.floor(mouseY / unitW);
	var ind = lX + lY * liquidW;

	//liquid[ind].fX += dM.x*10;
	//liquid[ind].fY += dM.y*10;

	for (var i = 0; i < liquidW; i++) {
		for (var j = 0; j < liquidH; j++) {

			var ind2 = i + j * liquidW;
			var dist = Math.abs(lY - j) + Math.abs(lX - i);
			var atten = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(dist, 0, liquidH * 0.2, 1, 0, true) * 0.3;
			if (ind2 < liquidW * liquidH) {
				liquid[ind2].force.add(dM.clone().multiplyScalar(atten));
			}
		}
	}

	//liquid[ind].force.add(dM);

	//spawn part
	for (var i = 0; i < 5; i++) {

		var ang = (Math.atan2(mouseY - 670 / 2, mouseX - 1200 / 2) / Math.PI * 180 + 360) % 360;
		var hue;
		if (ang > 180) {
			hue = Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(ang, 180, 360, 15, 40, true));
		} else {
			hue = Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["b" /* ofMap */])(ang, 0, 180, 200, 230, true));
		}
		//var brightness = Math.floor(ofRandom(40,70));
		hue = 50;
		var brightness = 100;

		var col = new THREE.Color("hsl( " + hue + ", 100%, " + brightness + "%)");
		//var col = new THREE.Color("hsl( 50, 0%, 50%)");

		spawnPart(mouseX + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(-5, 5), mouseY + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(-5, 5), col.r * 255, col.g * 255, col.b * 255, partLife + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__p__["a" /* ofRandom */])(0, 50));
		partTotal++;
	}
}

function spawnPart(x, y, r, g, b, life) {
	var id = getFreePart();
	//var color = new THREE.Color("hsl(0, 0%, "+Math.floor(ofRandom(50,100))+"%)");
	if (id != -1) {
		var obj = partSys[id];
		obj.isActive = true;
		obj.pos.set(x, y);
		obj.life = life;
		obj.posHis = new Array();
		//var color = new THREE.Color("hsl("+Math.floor(t%255 )+", 100%, "+Math.floor(ofRandom(0,100))+"%)");
		var color = new THREE.Color("rgb(" + Math.floor(r) + ", " + Math.floor(g) + ", " + Math.floor(b) + ")");
		obj.color = color;
		obj.cR = r;
		obj.cG = g;
		obj.cB = b;
		obj.strokeStyle = "#" + color.getHexString();
	}
}

function getPartID(x, y) {}

function getFreePart() {
	var id = -1;
	for (var i = 0; i < partMax; i++) {
		var obj = partSys[i];
		if (!obj.isActive) {
			id = i;
			break;
		}
	}
	return id;
}

function drawPixel(canvasData, x, y, r, g, b, a) {
	var index = (x + y * canvas.width) * 4;
	canvasData.data[index + 0] = r;
	canvasData.data[index + 1] = g;
	canvasData.data[index + 2] = b;
	canvasData.data[index + 3] = a;
}

function enterCover() {
	cover.tween = new TWEEN.Tween(cover).to({ scale2: 1.2 }, 500).easing(TWEEN.Easing.Quintic.InOut).start();
}

function leaveCover() {
	cover.tween = new TWEEN.Tween(cover).to({ scale2: 1 }, 500).easing(TWEEN.Easing.Quintic.InOut).start();
}

function minifyCover(isAnimated) {
	cover.isOn = false;
	var scale = 0.0001;
	if (isAnimated) {
		cover.tween = new TWEEN.Tween(cover).to({ scale: scale }, 2000).easing(TWEEN.Easing.Quintic.Out).start();
	} else {
		cover.scale = scale;
	}
}

function closeCover(isAnimated) {
	cover.isOn = true;
	var scale = getCoverCloseScale();
	if (isAnimated) {
		cover.tween = new TWEEN.Tween(cover).to({ scale: scale }, 2000).easing(TWEEN.Easing.Quintic.Out).start();

		if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* detectIE */])()) {
			setCutOffFreq(2000);
		}
	} else {
		cover.scale = scale;
	}
}

function expandCover(isAnimated) {
	cover.isOn = false;
	var scale = getCoverExpandScale();
	if (isAnimated) {
		cover.tween = new TWEEN.Tween(cover).to({ scale: scale }, 2000).easing(TWEEN.Easing.Quintic.InOut).start();

		if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* detectIE */])()) {
			setCutOffFreq(20000);
		}
	} else {
		cover.scale = scale;
	}
}

function getCoverCloseScale() {

	return Math.min(window.innerWidth, window.innerHeight) / 340 * 0.75;
}
function getCoverExpandScale() {
	var wh = window.innerHeight;
	var ww = window.innerWidth;
	return Math.sqrt(wh * wh + ww * ww) / 84;
}

//function checkScroll() {}

function checkResize() {
	if (coverCanvas) {
		coverCanvas.width = window.innerWidth;
		coverCanvas.height = window.innerHeight;

		if (cover.tween) {
			cover.tween.stop();
		}
		if (cover.isOn) {
			closeCover(false);
		} else {
			expandCover(false);
		}

		//THREE
		if (camera) {
			camera.aspect = window.innerWidth / window.innerHeight;
			camera.updateProjectionMatrix();
		}
		if (renderer) {
			renderer.setSize(window.innerWidth, window.innerHeight);
		}

		//part
		if (_mode == 50) {
			partCanvas.width = 1024;
			partCanvas.height = 1024;
		} else {
			partCanvas.width = window.innerWidth;
			partCanvas.height = window.innerHeight;
		}

		//if()
		//$(".section").height(wh);
	}
}

function easeInOutCubic(x, t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
	return c / 2 * ((t -= 2) * t * t + 2) + b;
}

function enterSite() {
	changeMode(40);
}

// Do not delete

if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* detectIE */])()) {
	var filter = new Tone.Filter(2000, "lowpass").toMaster();

	var player = new Tone.Player({
		"url": "https://www.victoriadockside.com/static/VIctoria_Dockside_oct26.mp3",
		"loop": true
	}).connect(filter);

	player.autostart = false;
}

function setCutOffFreq(freq) {
	filter.frequency.input.value = freq;
}
function stopMusic() {
	var audioElement = document.getElementById('bg-music');

	if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* detectIE */])()) {
		player.stop();
		audioElement.setAttribute('data-status', 'paused');
	} else {
		audioElement.pause();
		audioElement.setAttribute('data-status', 'paused');
	}
}
function startMusic() {
	var audioElement = document.getElementById('bg-music');
	var status = void 0;

	if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* detectIE */])()) {
		audioElement.muted = true;
		audioElement.play();

		if (audioElement.paused) {
			status = 'paused';
		} else {
			status = 'playing';
		}

		audioElement.setAttribute('data-status', status);
		audioElement.pause();
		audioElement.muted = false;

		player.start();
	} else {
		audioElement.play();

		if (audioElement.paused) {
			status = 'paused';
		} else {
			status = 'playing';
		}

		audioElement.setAttribute('data-status', status);
	}
}



/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_progressbar__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(178);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

var options = {
  color: '#fff',
  failedColor: '#874b4b',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  position: 'fixed',
  inverse: false
};

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vue_progressbar___default.a, options);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-requestanimationframe-touchevents-webaudio-webgl-setclasses !*/
!function (e, n, t) {
  function r(e, n) {
    return (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e)) === n;
  }function o() {
    var e, n, t, o, i, s, a;for (var f in y) {
      if (y.hasOwnProperty(f)) {
        if (e = [], n = y[f], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t < n.options.aliases.length; t++) {
          e.push(n.options.aliases[t].toLowerCase());
        }for (o = r(n.fn, "function") ? n.fn() : n.fn, i = 0; i < e.length; i++) {
          s = e[i], a = s.split("."), 1 === a.length ? Modernizr[a[0]] = o : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = o), g.push((o ? "" : "no-") + a.join("-"));
        }
      }
    }
  }function i(e) {
    var n = x.className,
        t = Modernizr._config.classPrefix || "";if (w && (n = n.baseVal), Modernizr._config.enableJSClass) {
      var r = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");n = n.replace(r, "$1" + t + "js$2");
    }Modernizr._config.enableClasses && (n += " " + t + e.join(" " + t), w ? x.className.baseVal = n : x.className = n);
  }function s() {
    return "function" != typeof n.createElement ? n.createElement(arguments[0]) : w ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments);
  }function a() {
    var e = n.body;return e || (e = s(w ? "svg" : "body"), e.fake = !0), e;
  }function f(e, t, r, o) {
    var i,
        f,
        u,
        l,
        p = "modernizr",
        d = s("div"),
        c = a();if (parseInt(r, 10)) for (; r--;) {
      u = s("div"), u.id = o ? o[r] : p + (r + 1), d.appendChild(u);
    }return i = s("style"), i.type = "text/css", i.id = "s" + p, (c.fake ? c : d).appendChild(i), c.appendChild(d), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(n.createTextNode(e)), d.id = p, c.fake && (c.style.background = "", c.style.overflow = "hidden", l = x.style.overflow, x.style.overflow = "hidden", x.appendChild(c)), f = t(d, e), c.fake ? (c.parentNode.removeChild(c), x.style.overflow = l, x.offsetHeight) : d.parentNode.removeChild(d), !!f;
  }function u(e) {
    return e.replace(/([a-z])-([a-z])/g, function (e, n, t) {
      return n + t.toUpperCase();
    }).replace(/^-/, "");
  }function l(e, n) {
    return !!~("" + e).indexOf(n);
  }function p(e, n) {
    return function () {
      return e.apply(n, arguments);
    };
  }function d(e, n, t) {
    var o;for (var i in e) {
      if (e[i] in n) return t === !1 ? e[i] : (o = n[e[i]], r(o, "function") ? p(o, t || n) : o);
    }return !1;
  }function c(e) {
    return e.replace(/([A-Z])/g, function (e, n) {
      return "-" + n.toLowerCase();
    }).replace(/^ms-/, "-ms-");
  }function m(n, r) {
    var o = n.length;if ("CSS" in e && "supports" in e.CSS) {
      for (; o--;) {
        if (e.CSS.supports(c(n[o]), r)) return !0;
      }return !1;
    }if ("CSSSupportsRule" in e) {
      for (var i = []; o--;) {
        i.push("(" + c(n[o]) + ":" + r + ")");
      }return i = i.join(" or "), f("@supports (" + i + ") { #modernizr { position: absolute; } }", function (e) {
        return "absolute" == getComputedStyle(e, null).position;
      });
    }return t;
  }function v(e, n, o, i) {
    function a() {
      p && (delete j.style, delete j.modElem);
    }if (i = r(i, "undefined") ? !1 : i, !r(o, "undefined")) {
      var f = m(e, o);if (!r(f, "undefined")) return f;
    }for (var p, d, c, v, h, g = ["modernizr", "tspan", "samp"]; !j.style && g.length;) {
      p = !0, j.modElem = s(g.shift()), j.style = j.modElem.style;
    }for (c = e.length, d = 0; c > d; d++) {
      if (v = e[d], h = j.style[v], l(v, "-") && (v = u(v)), j.style[v] !== t) {
        if (i || r(o, "undefined")) return a(), "pfx" == n ? v : !0;try {
          j.style[v] = o;
        } catch (y) {}if (j.style[v] != h) return a(), "pfx" == n ? v : !0;
      }
    }return a(), !1;
  }function h(e, n, t, o, i) {
    var s = e.charAt(0).toUpperCase() + e.slice(1),
        a = (e + " " + z.join(s + " ") + s).split(" ");return r(n, "string") || r(n, "undefined") ? v(a, n, o, i) : (a = (e + " " + T.join(s + " ") + s).split(" "), d(a, n, t));
  }var g = [],
      y = [],
      C = { _version: "3.3.1", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, n) {
      var t = this;setTimeout(function () {
        n(t[e]);
      }, 0);
    }, addTest: function addTest(e, n, t) {
      y.push({ name: e, fn: n, options: t });
    }, addAsyncTest: function addAsyncTest(e) {
      y.push({ name: null, fn: e });
    } },
      Modernizr = function Modernizr() {};Modernizr.prototype = C, Modernizr = new Modernizr(), Modernizr.addTest("webaudio", function () {
    var n = "webkitAudioContext" in e,
        t = "AudioContext" in e;return Modernizr._config.usePrefixes ? n || t : t;
  });var x = n.documentElement,
      w = "svg" === x.nodeName.toLowerCase(),
      b = C._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];C._prefixes = b, Modernizr.addTest("webgl", function () {
    var n = s("canvas"),
        t = "probablySupportsContext" in n ? "probablySupportsContext" : "supportsContext";return t in n ? n[t]("webgl") || n[t]("experimental-webgl") : "WebGLRenderingContext" in e;
  });var _ = C.testStyles = f;Modernizr.addTest("touchevents", function () {
    var t;if ("ontouchstart" in e || e.DocumentTouch && n instanceof DocumentTouch) t = !0;else {
      var r = ["@media (", b.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");_(r, function (e) {
        t = 9 === e.offsetTop;
      });
    }return t;
  });var S = "Moz O ms Webkit",
      T = C._config.usePrefixes ? S.toLowerCase().split(" ") : [];C._domPrefixes = T;var z = C._config.usePrefixes ? S.split(" ") : [];C._cssomPrefixes = z;var E = function E(n) {
    var r,
        o = b.length,
        i = e.CSSRule;if ("undefined" == typeof i) return t;if (!n) return !1;if (n = n.replace(/^@/, ""), r = n.replace(/-/g, "_").toUpperCase() + "_RULE", r in i) return "@" + n;for (var s = 0; o > s; s++) {
      var a = b[s],
          f = a.toUpperCase() + "_" + r;if (f in i) return "@-" + a.toLowerCase() + "-" + n;
    }return !1;
  };C.atRule = E;var P = { elem: s("modernizr") };Modernizr._q.push(function () {
    delete P.elem;
  });var j = { style: P.elem.style };Modernizr._q.unshift(function () {
    delete j.style;
  }), C.testAllProps = h;var N = C.prefixed = function (e, n, t) {
    return 0 === e.indexOf("@") ? E(e) : (-1 != e.indexOf("-") && (e = u(e)), n ? h(e, n, t) : h(e, "pfx"));
  };Modernizr.addTest("requestanimationframe", !!N("requestAnimationFrame", e), { aliases: ["raf"] }), o(), i(g), delete C.addTest, delete C.addAsyncTest;for (var k = 0; k < Modernizr._q.length; k++) {
    Modernizr._q[k]();
  }e.Modernizr = Modernizr;
}(window, document);

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ofClamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ofRandom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ofMap; });


var ww, wh, sw, sh, ws;

function us() {
    //update window size
    ww = $(window).width();
    //ww = Math.max(1024,ww);
    wh = $(window).height();
    sw = screen.width;
    sh = screen.height;
    //ws = $(window).scrollTop();
    ws = $(document).scrollTop();
    //ws = window.pageYOffset;
}
function nopx(s) {
    if (s == "undefined" || s == null) {
        s = "0";
    }
    var i = parseInt(s.replace("px", ""));
    return Number(i);
}
function nl2br(str, is_xhtml) {
    var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}
function nl2br2(str, is_xhtml) {
    //for markdown only
    var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br class="br"/>' : '<br class="br">';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}
function nlRemove(str) {
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '' + '$2');
}

function ofRandom(a, b) {
    return Math.random() * (b - a) + a;
}
function ofMap(X, A, B, C, D, isClamp) {
    var Y = (X - A) / (B - A) * (D - C) + C;
    if (isClamp) {
        Y = ofClamp(Y, C, D);
    }
    return Y;
}
function ofClamp(v, a, b) {
    if (a > b) {
        var a2 = a;
        a = b;
        b = a2;
    }
    return Math.min(Math.max(v, a), b);
}



/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

module.exports = {
	"en": {
		"mainSections": [
			{
				"menu": {
					"id": 0,
					"name": "Intro",
					"url": ""
				},
				"mainSectionTitle": "100 Creative<br>Powers",
				"mainSectionExcerpt": "<p>Welcome to Victoria Dockside, the art and design district for culture, creativity and innovation, connecting global millennials to collide. This is the new face of the Hong Kong harbour-front.</p><p>Meet the 100 Creative Powers behind this cultural destination, who are inspiring new waves of disruption in architecture, art, culture, design and sustainability for tomorrow’s generation.</p>",
				"mainSectionIntro": "<p>Welcome to Victoria Dockside, the art and design district for culture, creativity and innovation, connecting global millennials to collide. This is the new face of the Hong Kong harbour-front.</p><p>Meet the 100 Creative Powers behind this cultural destination, who are inspiring new waves of disruption in architecture, art, culture, design and sustainability for tomorrow’s generation.</p>",
				"hasLink": true,
				"link": "enter",
				"externalUrl": "https://www.victoriadockside.com/100-creative-powers/en",
				"openExternal": true,
				"hasSubsection": false,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "enter",
				"videoSrc": {
					"desktop": "static/video/intro-compress27.mp4",
					"mobile": "static/video/mobile/intro8-mobile_compressed32.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Intro-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Intro-p-mobile.jpg"
				}
			},
			{
				"menu": {
					"id": 1,
					"name": "Heritage",
					"url": ""
				},
				"mainSectionTitle": "A history <br/> of making waves",
				"mainSectionExcerpt": "<p>Victoria Dockside is built on the site formerly known as Holt&rsquo;s Wharf. Founded in 1910, Holt&rsquo;s Wharf served as a global freight and logistics hub...</p>",
				"mainSectionIntro": "<p>Victoria Dockside is built on the site formerly known as Holt&rsquo;s Wharf. Founded in 1910, Holt&rsquo;s Wharf served as a global freight and logistics hub that helped establish Hong Kong as a gateway to the Far East and played a major role in the city becoming the busiest port in the world.</p><p>The location has a long history of transformation, being a game-changer in art, design, business and leisure.</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "read more",
				"videoSrc": {
					"desktop": "static/video/Heritage-fade-compress23.mp4",
					"mobile": "static/video/mobile/Heritage-mobile-fade_compressed-32.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Heritage-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Heritage-p-mobile.jpg"
				},
				"subSection": [
					{
						"id": "1",
						"year": "1906",
						"title": "1906 First cross harbour race",
						"hasText": true,
						"text": "This was the starting point for what has become one of Hong Kong’s oldest traditions",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-01.jpg",
							"mobile": "static/bg-heritage-mobile-1.jpg",
							"alt": "1906 First cross harbour race"
						},
						"hasDetail": false
					},
					{
						"id": "2",
						"year": "1910",
						"title": "1910 Kowloon-Canton railway completed",
						"hasText": true,
						"text": "This was part of the first Hong Kong railway line to connect South China with the world",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-02.jpg",
							"mobile": "static/bg-heritage-mobile-2.jpg",
							"alt": "1910 Kowloon-Canton railway completed"
						},
						"hasDetail": false
					},
					{
						"id": "3",
						"year": "1980",
						"title": "1980 Hong Kong space museum opened",
						"hasText": true,
						"text": "This popular museum is where Hong Kong first reached out to the stars",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-04.jpg",
							"mobile": "static/bg-heritage-mobile-4.jpg",
							"alt": "1980 Hong Kong space museum opened"
						},
						"hasDetail": false
					},
					{
						"id": "4",
						"year": "1989",
						"title": "1989 Hong Kong cultural centre opened",
						"hasText": true,
						"text": "This harbour-front icon represents the cultural heart of Hong Kong",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-05.jpg",
							"mobile": "static/bg-heritage-mobile-5.jpg",
							"alt": "1989 Hong Kong cultural centre opened"
						},
						"hasDetail": false
					},
					{
						"id": "5",
						"year": "1991",
						"title": "1991 Hong Kong museum of art opened",
						"hasText": true,
						"text": "This is where Hong Kong exhibits and celebrates its most valued artistic treasures",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-06.jpg",
							"mobile": "static/bg-heritage-mobile-6.jpg",
							"alt": "1991 Hong Kong museum of art opened"
						},
						"hasDetail": false
					},
					{
						"id": "6",
						"year": "2003",
						"title": "2003 Avenue of stars",
						"hasText": true,
						"text": "This cultural landmark became Hong Kong’s most visited tourist attraction",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "right-to-left",
						"bgSrc": {
							"desktop": "static/bg-heritage-07.jpg",
							"mobile": "static/bg-heritage-mobile-7.jpg",
							"alt": "2003 Avenue of stars"
						},
						"hasDetail": false
					}
				]
			},
			{
				"menu": {
					"id": 2,
					"name": "Design",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br/>in design",
				"mainSectionExcerpt": "<p>Located at the epicentre of Hong Kong, the Tsim Sha Tsui harbour-front, Victoria Dockside will set new precedents in architecture and will help transform the iconic Hong Kong skyline.</p>",
				"mainSectionIntro": "<p>Located at the epicentre of Hong Kong, the Tsim Sha Tsui harbour-front, Victoria Dockside will set new precedents in architecture and will help transform the iconic Hong Kong skyline.</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "read more",
				"videoSrc": {
					"desktop": "static/video/design-compress21.mp4",
					"mobile": "static/video/mobile/Design-mobile_compressed30.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Design-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Design-p-mobile.jpg",
					"alt": "Victoria dockside Make waves in design"
				},
				"subSection": [
					{
						"id": "1",
						"title": "ARCHITECTURE BY<br/>KOHN PEDERSEN FOX ASSOCIATES",
						"hasText": true,
						"text": "<p>This new destination was designed by acclaimed New York-based Kohn Pedersen Fox Associates (KPF) - one of the world&rsquo;s largest architecture firms. Renowned for creating Roppongi Hills in Tokyo,<strong><em> </em></strong>KPF is creating a new aesthetic benchmark with the use of timeless materials.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-01.jpg",
							"mobile": "static/bg-design-mobile-01.jpg",
							"alt": "Victoria dockside ARCHITECTURE BY KOHN PEDERSEN FOX ASSOCIATES"
						},
						"hasDetail": false
					},
					{
						"id": "2",
						"title": "ARCHITECTURE BY<br/>KOHN PEDERSEN FOX ASSOCIATES",
						"hasText": true,
						"text": "<p>This new destination was designed by acclaimed New York-based Kohn Pedersen Fox Associates (KPF) - one of the world&rsquo;s largest architecture firms. Renowned for creating Roppongi Hills in Tokyo,<strong><em> </em></strong>KPF is creating a new aesthetic benchmark with the use of timeless materials.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-02.jpg",
							"mobile": "static/bg-design-mobile-02.jpg",
							"alt": "Victoria dockside ARCHITECTURE BY KOHN PEDERSEN FOX ASSOCIATES"
						},
						"hasDetail": false
					},
					{
						"id": "3",
						"title": "Make <br/>natural waves",
						"hasText": true,
						"text": "<p>Victoria Dockside will mark a turning point in the urban development of Hong Kong and a return to nature and greenery.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-07.jpg",
							"mobile": "static/bg-design-mobile-07.jpg",
							"alt": "Victoria dockside Make natural waves"
						},
						"hasDetail": false
					},
					{
						"id": "4",
						"title": "Make <br/>natural waves",
						"hasText": true,
						"text": "<p>Victoria Dockside will mark a turning point in the urban development of Hong Kong and a return to nature and greenery.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-05.jpg",
							"mobile": "static/bg-design-mobile-05.jpg",
							"alt": "Victoria dockside Make natural waves"
						},
						"hasDetail": false
					},
					{
						"id": "5",
						"title": "Landscape design by<br/>James Corner Field Operations",
						"hasText": true,
						"text": "<p>James Corner Field Operations creator of New York&rsquo;s iconic High Line concept has been enlisted to transform the harbour-front into an oasis of green spaces to provide the city, residents and visitors, inspiring new breathing space.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": "static/video/james-corner-desktop.mp4",
							"mobile": "static/video/james-corner-mobile.mp4"
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-03.jpg",
							"mobile": "static/bg-design-mobile-03.jpg",
							"alt": "Victoria dockside Landscape design by James Corner Field Operations"
						},
						"hasDetail": false
					},
					{
						"id": "6",
						"title": "Landscape design by<br/>James Corner Field Operations",
						"hasText": true,
						"text": "<p>James Corner Field Operations creator of New York&rsquo;s iconic High Line concept has been enlisted to transform the harbour-front into an oasis of green spaces to provide the city, residents and visitors, inspiring new breathing space.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-06.jpg",
							"mobile": "static/bg-design-mobile-06.jpg",
							"alt": "Victoria dockside Landscape design by James Corner Field Operations"
						},
						"hasDetail": false
					}
				]
			},
			{
				"menu": {
					"id": 3,
					"name": "Art",
					"url": ""
				},
				"mainSectionTitle": "Make waves <br class='hidden-xs'/>in art",
				"mainSectionExcerpt": "<p>Victoria Dockside provides a new creative heart for Hong Kong. A place where art, culture and craftsmanship is encouraged and amplified.</p>",
				"mainSectionIntro": "<p>Victoria Dockside provides a new creative heart for Hong Kong. A place where art, culture and craftsmanship is encouraged and amplified.</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": false,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "read more",
				"videoSrc": {
					"desktop": "static/video/art2-compress28.mp4",
					"mobile": "static/video/mobile/art2-mobile_compressed33.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Art-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Art-p-mobile.jpg",
					"alt": "Victoria dockside Make waves in art"
				}
			},
			{
				"menu": {
					"id": 4,
					"name": "Work Place",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br/>in the work place",
				"mainSectionExcerpt": "",
				"mainSectionIntro": "",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"hasVideo": true,
				"button": "read more",
				"showDetailFront": false,
				"videoSrc": {
					"desktop": "static/video/workplace-compress30.mp4",
					"mobile": "static/video/mobile/Workplace-mobile_compressed30.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Workplace-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Workplace-p-mobile.jpg",
					"alt": "Victoria dockside Make waves in the work place"
				},
				"subSection": [
					{
						"id": "1",
						"title": "",
						"hasText": true,
						"text": "<p>Victoria Dockside offers a new epicentre for game-changers in the world of business and innovation. Grade A office spaces combine the greatest new views of the city with versatile open plan design.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-work-01.jpg",
							"mobile": "static/bg-work-mobile-1.jpg",
							"alt": "Victoria dockside Make waves in the work place"
						},
						"hasDetail": false,
						"hasLink": false,
						"link": "Office site"
					},
					{
						"id": "2",
						"title": "",
						"hasText": true,
						"text": "",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-work-02.jpg",
							"mobile": "static/bg-work-mobile-2.jpg",
							"alt": "Victoria dockside Make waves in the work place"
						},
						"hasDetail": false,
						"hasLink": true,
						"link": "K11 Atelier office site",
						"externalUrl": "https://www.k11atelier.com/"
					}
				]
			},
			{
				"menu": {
					"id": 5,
					"name": "Hospitality",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br class='hidden-xs'/> in hospitality",
				"mainSectionExcerpt": "<p>Rosewood Hotels &amp; Resorts&reg; is poised to unveil its latest premiere property on the Victoria Harbour waterfront at Victoria Dockside.</p>",
				"mainSectionIntro": "<p>Rosewood Hotels &amp; Resorts&reg; is poised to unveil its latest premiere property on the Victoria Harbour waterfront at Victoria Dockside.</p>",
				"hasLink": true,
				"link": "Rosewood Hong Kong",
				"hasSubsection": false,
				"showDetailFront": false,
				"openExternal": true,
				"externalUrl": "https://www.rosewoodhotels.com/en/hong-kong",
				"hasVideo": false,
				"button": "enter",
				"videoSrc": {
					"desktop": "static/video/Rosewood.mp4",
					"mobile": "static/video/Rosewood.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/Rosewood.jpg",
					"mobile": "static/rosewood_mobile.jpg",
					"alt": "Victoria dockside Make waves in hospitality"
				},
				"subSection": null
			}
		],
		"location": {
			"menu": {
				"id": 7,
				"name": "Location",
				"url": ""
			},
			"mainSectionTitle": "Location",
			"mainSectionExcerpt": "<p>Victoria Dockside is located at the epicentre Hong Kong, the Tsim Sha Tsui harbour-front.</p><p>18 Salisbury Road,<br/>Tsim Sha Tsui,<br/>Hong Kong</p>",
			"mainSectionIntro": "<p>Victoria Dockside is located at the epicentre Hong Kong, the Tsim Sha Tsui harbour-front.</p><p>18 Salisbury Road,<br/>Tsim Sha Tsui,<br/>Hong Kong</p>",
			"hasLink": true,
			"link": "Google Map",
			"hasSubsection": false,
			"showDetailFront": false,
			"openExternal": true,
			"externalUrl": "https://goo.gl/maps/D4sfhYNnxKx",
			"hasVideo": false,
			"button": "Enter",
			"videoSrc": {
				"desktop": "static/video/Intro8_compressed31-5.mp4",
				"mobile": "static/video/mobile/intro8-mobile_compressed32.mp4"
			},
			"pan": "left-to-right",
			"bgSrc": {
				"desktop": "static/vds_locationpage_en.jpg",
				"mobile": "static/vds_mobilemap_en_m.jpg",
				"alt": "Victoria dockside location"
			},
			"subSection": null
		},
		"event": {
			"menu": {
				"id": 8,
				"name": "Event",
				"url": ""
			},
			"mainSectionTitle": "Event",
			"mainSectionExcerpt": "<p>Discover what’s on at Victoria Dockside</p>",
			"mainSectionIntro": "<p>Discover what’s on at Victoria Dockside</p>",
			"hasLink": true,
			"link": "See Event",
			"hasSubsection": false,
			"showDetailFront": false,
			"openExternal": true,
			"externalUrl": "/event",
			"hasVideo": true,
			"button": "See Event",
			"videoSrc": {
				"desktop": "static/video/Event3-20.mp4",
				"mobile": "static/video/mobile/Event3_m_27.mp4"
			},
			"pan": "left-to-right",
			"bgSrc": {
				"desktop": "static/video/poster/event.jpg",
				"mobile": "static/video/mobile/poster/event-mobile.jpg",
				"alt": "Victoria dockside Event"
			},
			"subSection": null,
			"pageContent": {
				"title": "EVENT",
				"description": "text"
			}
		},
		"menu": [
			{
				"id": 0,
				"name": "Intro"
			},
			{
				"id": 999,
				"name": "100 Creative Powers"
			},
			{
				"id": 1,
				"name": "Heritage"
			},
			{
				"id": 2,
				"name": "Design"
			},
			{
				"id": 3,
				"name": "Art"
			},
			{
				"id": 4,
				"name": "Work Place"
			},
			{
				"id": 5,
				"name": "Hospitality"
			},
			{
				"id": 6,
				"name": "Press"
			},
			{
				"id": 7,
				"name": "Location"
			},
			{
				"id": 8,
				"name": "Event"
			}
		]
	},
	"tc": {
		"mainSections": [
			{
				"menu": {
					"id": 0,
					"name": "Intro",
					"url": ""
				},
				"mainSectionTitle": "100份<br>創意力量",
				"mainSectionExcerpt": "<p>歡迎來到Victoria Dockside，全球新世代將聚首於這個藝術、設計與文化新焦點，激發靈感創意，以創新思維迸發更多可能，重塑香港海濱的新風貌。</p><p>認識共同塑造這個文化新地標的一百份創意力量，他們為新世代的建築、藝術、文化、設計及可持續發展掀起新一波浪潮。</p>",
				"mainSectionIntro": "<p>歡迎來到Victoria Dockside，全球新世代將聚首於這個藝術、設計與文化新焦點，激發靈感創意，以創新思維迸發更多可能，重塑香港海濱的新風貌。</p><p>認識共同塑造這個文化新地標的一百份創意力量，他們為新世代的建築、藝術、文化、設計及可持續發展掀起新一波浪潮。</p>",
				"hasLink": true,
				"link": "進入",
				"hasSubsection": false,
				"externalUrl": "https://www.victoriadockside.com/100-creative-powers/tc",
				"showDetailFront": false,
				"openExternal": true,
				"hasVideo": true,
				"button": "進入",
				"videoSrc": {
					"desktop": "static/video/intro-compress27.mp4",
					"mobile": "static/video/mobile/intro8-mobile_compressed32.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Intro-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Intro-p-mobile.jpg",
					"alt": "認識為香港建構全新文化地標的100份創意力量"
				}
			},
			{
				"menu": {
					"id": 1,
					"name": "Heritage",
					"url": ""
				},
				"mainSectionTitle": "A history <br/> of making waves",
				"mainSectionExcerpt": "<p>Victoria Dockside前身為藍煙囪碼頭，於1910年代是環球航運及物流樞紐。</p>",
				"mainSectionIntro": "<p>Victoria Dockside前身為藍煙囪碼頭，於1910年代是環球航運及物流樞紐。作為通向遠東的大門，藍煙囪碼頭有助香港奠定國際上的地位，帶動香港成為全球最繁忙的港口。</p><p>源遠流長的地理優勢，造就藝術、文化、酒店服務及商界的破格演變。</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "閱讀更多",
				"videoSrc": {
					"desktop": "static/video/Heritage-fade-compress23.mp4",
					"mobile": "static/video/mobile/Heritage-mobile-fade_compressed-32.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Heritage-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Heritage-p-mobile.jpg",
					"alt": "Victoria Dockside A history of making waves"
				},
				"subSection": [
					{
						"id": "1",
						"year": "1906",
						"title": "1906 首屆維港渡海泳",
						"hasText": true,
						"text": "香港其中一項歷史最悠久的大型活動",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-01.jpg",
							"mobile": "static/bg-heritage-mobile-1.jpg",
							"alt": "Victoria Dockside 1906 首屆維港渡海泳"
						},
						"hasDetail": false
					},
					{
						"id": "2",
						"year": "1910",
						"title": "1910 九廣鐵路通車",
						"hasText": true,
						"text": "成功將香港與南中國接軌的起步點",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-02.jpg",
							"mobile": "static/bg-heritage-mobile-2.jpg",
							"alt": "Victoria Dockside 1910 九廣鐵路通車"
						},
						"hasDetail": false
					},
					{
						"id": "3",
						"year": "1980",
						"title": "1980 香港太空館啟用",
						"hasText": true,
						"text": "帶領香港人探索天際的重要基地",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-04.jpg",
							"mobile": "static/bg-heritage-mobile-4.jpg",
							"alt": "Victoria Dockside 1980 香港太空館啟用"
						},
						"hasDetail": false
					},
					{
						"id": "4",
						"year": "1989",
						"title": "1989 香港文化中心啟用",
						"hasText": true,
						"text": "代表中西文化精髓的臨海地標",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-05.jpg",
							"mobile": "static/bg-heritage-mobile-5.jpg",
							"alt": "Victoria Dockside 1989 香港文化中心啟用"
						},
						"hasDetail": false
					},
					{
						"id": "5",
						"year": "1991",
						"title": "1991 香港藝術館啟用",
						"hasText": true,
						"text": "珍藏及展示古今中外藝術的文化典堂",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-06.jpg",
							"mobile": "static/bg-heritage-mobile-6.jpg",
							"alt": "Victoria Dockside 1991 香港藝術館啟用"
						},
						"hasDetail": false
					},
					{
						"id": "6",
						"year": "2003",
						"title": "2003 星光大道開幕",
						"hasText": true,
						"text": "標誌著香港蜚聲國際文化產業的旅遊重點",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "right-to-left",
						"bgSrc": {
							"desktop": "static/bg-heritage-07.jpg",
							"mobile": "static/bg-heritage-mobile-7.jpg",
							"alt": "Victoria Dockside 2003 星光大道開幕"
						},
						"hasDetail": false
					}
				]
			},
			{
				"menu": {
					"id": 2,
					"name": "Design",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br/>in design",
				"mainSectionExcerpt": "<p>貴為香港地區核心，屹立尖沙咀臨海地段，Victoria Dockside的前瞻性建築設計，令舉世知名的維港景觀耳目一新，繪寫匠心獨運的全新畫面。</p>",
				"mainSectionIntro": "<p>貴為香港地區核心，屹立尖沙咀臨海地段，Victoria Dockside的前瞻性建築設計，令舉世知名的維港景觀耳目一新，繪寫匠心獨運的全新畫面。</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "閱讀更多",
				"videoSrc": {
					"desktop": "static/video/design-compress21.mp4",
					"mobile": "static/video/mobile/Design-mobile_compressed30.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Design-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Design-p-mobile.jpg",
					"alt": "Victoria Dockside Make waves in design"
				},
				"subSection": [
					{
						"id": "1",
						"title": "Kohn Pedersen Fox Associates建築策劃",
						"hasText": true,
						"text": "<p>新地標的設計藍圖，出自享負盛名的紐約建築事務所Kohn Pedersen Fox Associates (KPF) 。建築巨匠KPF曾一手創造東京「六本木新城」，憑藉劃時代的設計思維，為當代建築界樹立美學標準。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-01.jpg",
							"mobile": "static/bg-design-mobile-01.jpg",
							"alt": "Victoria Dockside Kohn Pedersen Fox Associates建築策劃"
						},
						"hasDetail": false
					},
					{
						"id": "2",
						"title": "Kohn Pedersen Fox Associates建築策劃",
						"hasText": true,
						"text": "<p>新地標的設計藍圖，出自享負盛名的紐約建築事務所Kohn Pedersen Fox Associates (KPF) 。建築巨匠KPF曾一手創造東京「六本木新城」，憑藉劃時代的設計思維，為當代建築界樹立美學標準。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-02.jpg",
							"mobile": "static/bg-design-mobile-02.jpg",
							"alt": "Victoria Dockside Kohn Pedersen Fox Associates建築策劃"
						},
						"hasDetail": false
					},
					{
						"id": "3",
						"title": "Make <br/>natural waves",
						"hasText": true,
						"text": "<p>難得一見的綠化概念，於香港都心活現。Victoria Dockside率先領導市區發展，於建築群實現大規模綠化，為繁忙都心源源注氧。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-07.jpg",
							"mobile": "static/bg-design-mobile-07.jpg",
							"alt": "Victoria Dockside Make natural waves"
						},
						"hasDetail": false
					},
					{
						"id": "4",
						"title": "Make <br/>natural waves",
						"hasText": true,
						"text": "<p>難得一見的綠化概念，於香港都心活現。Victoria Dockside率先領導市區發展，於建築群實現大規模綠化，為繁忙都心源源注氧。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-05.jpg",
							"mobile": "static/bg-design-mobile-05.jpg",
							"alt": "Victoria Dockside Make natural waves"
						},
						"hasDetail": false
					},
					{
						"id": "5",
						"title": "James Corner Field Operations園境規劃",
						"hasText": true,
						"text": "<p>Victoria Dockside園境規劃設計師James Corner Field Operations (JCFO) ，成功創造紐約最具代表性的空中公園「High Line」，今日於香港揮灑創意，令維港海濱蛻變為綠化空間，為香港人及全球觀光客，開闢一片綠意天地。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": "static/video/james-corner-desktop.mp4",
							"mobile": "static/video/james-corner-mobile.mp4"
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-03.jpg",
							"mobile": "static/bg-design-mobile-03.jpg",
							"alt": "Victoria Dockside James Corner Field Operations園境規劃"
						},
						"hasDetail": false
					},
					{
						"id": "6",
						"title": "James Corner Field Operations園境規劃",
						"hasText": true,
						"text": "<p>Victoria Dockside園境規劃設計師James Corner Field Operations (JCFO) ，成功創造紐約最具代表性的空中公園「High Line」，今日於香港揮灑創意，令維港海濱蛻變為綠化空間，為香港人及全球觀光客，開闢一片綠意天地。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-06.jpg",
							"mobile": "static/bg-design-mobile-06.jpg",
							"alt": "Victoria Dockside James Corner Field Operations園境規劃"
						},
						"hasDetail": false
					}
				]
			},
			{
				"menu": {
					"id": 3,
					"name": "Art",
					"url": ""
				},
				"mainSectionTitle": "Make waves <br class='hidden-xs'/>in art",
				"mainSectionExcerpt": "<p>Victoria Dockside提供無邊無際的自由空間，讓藝術、設計、美藝及各個範疇的創意，於香港的核心大放異彩，造就世界級文化及創意地標。</p>",
				"mainSectionIntro": "<p>Victoria Dockside提供無邊無際的自由空間，讓藝術、設計、美藝及各個範疇的創意，於香港的核心大放異彩，造就世界級文化及創意地標。</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": false,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "閱讀更多",
				"videoSrc": {
					"desktop": "static/video/art2-compress28.mp4",
					"mobile": "static/video/mobile/art2-mobile_compressed33.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Art-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Art-p-mobile.jpg",
					"alt": "Victoria Dockside Make waves in art"
				}
			},
			{
				"menu": {
					"id": 4,
					"name": "Work Place",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br/>in the work place",
				"mainSectionExcerpt": "",
				"mainSectionIntro": "",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"hasVideo": true,
				"button": "閱讀更多",
				"showDetailFront": false,
				"videoSrc": {
					"desktop": "static/video/workplace-compress30.mp4",
					"mobile": "static/video/mobile/Workplace-mobile_compressed30.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Workplace-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Workplace-p-mobile.jpg",
					"alt": "Victoria Dockside Make waves in the work place"
				},
				"subSection": [
					{
						"id": "1",
						"title": "",
						"hasText": true,
						"text": "<p>Victoria Dockside為敢於破格的商界及創科精英，重新界定現代化工作空間。甲級辦公大樓的智慧型設計，將壯闊維港景致納進開放式室內規劃，思維及概念無限激發。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-work-01.jpg",
							"mobile": "static/bg-work-mobile-1.jpg",
							"alt": "Victoria Dockside Make waves in the work place"
						},
						"hasDetail": false,
						"hasLink": false,
						"link": "Office site"
					},
					{
						"id": "2",
						"title": "",
						"hasText": true,
						"text": "",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-work-02.jpg",
							"mobile": "static/bg-work-mobile-2.jpg",
							"alt": "Victoria Dockside Make waves in the work place"
						},
						"hasDetail": false,
						"hasLink": true,
						"link": "K11 Atelier office site",
						"externalUrl": "https://www.k11atelier.com/"
					}
				]
			},
			{
				"menu": {
					"id": 5,
					"name": "Hospitality",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br class='hidden-xs'/> in hospitality",
				"mainSectionExcerpt": "<p>世界級奢華品牌瑰麗酒店將於Victoria Dockside閃耀登場，將成為香港璀璨天際線的另一新地標。</p>",
				"mainSectionIntro": "<p>世界級奢華品牌瑰麗酒店將於Victoria Dockside閃耀登場，將成為香港璀璨天際線的另一新地標。</p>",
				"hasLink": true,
				"link": "Rosewood Hong Kong",
				"hasSubsection": false,
				"showDetailFront": false,
				"openExternal": true,
				"externalUrl": "https://www.rosewoodhotels.com/tc/hong-kong",
				"hasVideo": false,
				"button": "進入",
				"videoSrc": {
					"desktop": "static/video/Rosewood.mp4",
					"mobile": "static/video/Rosewood.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/Rosewood.jpg",
					"mobile": "static/rosewood_mobile.jpg",
					"alt": "Victoria Dockside Make waves in hospitality"
				},
				"subSection": null
			}
		],
		"location": {
			"menu": {
				"id": 7,
				"name": "Location",
				"url": ""
			},
			"mainSectionTitle": "Location",
			"mainSectionExcerpt": "<p>Victoria Dockside位處尖沙咀海濱。</p><p>香港九龍尖沙咀梳士巴利道18號</p>",
			"mainSectionIntro": "<p>Victoria Dockside位處尖沙咀海濱。</p><p>香港九龍尖沙咀梳士巴利道18號</p>",
			"hasLink": true,
			"link": "Google Map",
			"hasSubsection": false,
			"showDetailFront": false,
			"openExternal": true,
			"externalUrl": "https://goo.gl/maps/Cmk4CnJ37pC2",
			"hasVideo": false,
			"button": "進入",
			"videoSrc": {
				"desktop": "static/video/Intro8_compressed31-5.mp4",
				"mobile": "static/video/mobile/intro8-mobile_compressed32.mp4"
			},
			"pan": "left-to-right",
			"bgSrc": {
				"desktop": "static/vds_locationpage_cn.jpg",
				"mobile": "static/vds_locationpage_cn_m.jpg",
				"alt": "Victoria Dockside location"
			},
			"subSection": null
		},
		"event": {
			"menu": {
				"id": 8,
				"name": "Event",
				"url": ""
			},
			"mainSectionTitle": "Event",
			"mainSectionExcerpt": "<p>發掘更多在 Victoria Dockside 掀起的革新浪潮</p>",
			"mainSectionIntro": "<p>發掘更多在 Victoria Dockside 掀起的革新浪潮</p>",
			"hasLink": true,
			"link": "See Event",
			"hasSubsection": false,
			"showDetailFront": false,
			"openExternal": true,
			"externalUrl": "/tc/event",
			"hasVideo": true,
			"button": "See Event",
			"videoSrc": {
				"desktop": "static/video/Event3-20.mp4",
				"mobile": "static/video/mobile/Event3_m_27.mp4"
			},
			"pan": "left-to-right",
			"bgSrc": {
				"desktop": "static/video/poster/event.jpg",
				"mobile": "static/video/mobile/poster/event-mobile.jpg",
				"alt": "Victoria dockside Event"
			},
			"subSection": null,
			"pageContent": {
				"title": "EVENT",
				"description": "text"
			}
		},
		"menu": [
			{
				"id": 0,
				"name": "Intro"
			},
			{
				"id": 999,
				"name": "100 Creative Powers"
			},
			{
				"id": 1,
				"name": "Heritage"
			},
			{
				"id": 2,
				"name": "Design"
			},
			{
				"id": 3,
				"name": "Art"
			},
			{
				"id": 4,
				"name": "Work Place"
			},
			{
				"id": 5,
				"name": "Hospitality"
			},
			{
				"id": 6,
				"name": "Press"
			},
			{
				"id": 7,
				"name": "Location"
			},
			{
				"id": 8,
				"name": "Event"
			}
		]
	}
};

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[219]);


// WEBPACK FOOTER //
// static/js/app.4692d1eacccc23874469.js